<template>
  <div>
    <loading-spinner :visible="isLoading" />
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-0">
      <div class="main p-0 text-center">
        <div class="alert alert-success" role="alert">
          <b class="fs-3">행 사 상 세 정 보</b>
        </div>

        <div class="text-success text-start fs-6 mb-2 section-title">
          <b>[ &nbsp; 기본정보 ( {{ this.dealInfoDetail.dealCode }} )&nbsp; ]</b>
          <span style="color: red; font-weight: 600;" v-if="this.newDealFlag === 'Y'"> 신정산 </span>
        </div>
        <table class="table table-bordered table-striped fs-6">
          <thead class="small">
            <tr>
              <th style="width:60px;"><span class="text-danger">*</span>상태</th>
              <th style="width:120px;">행사명(<span class="text-danger">*</span>국문/영문)</th>
              <th style="width:70px;">누적판매액</th>
              <th style="width:70px;"><span class="text-danger">*</span>예약자</th>
              <th style="width:90px;"><span class="text-danger">*</span>전화/이메일</th>
              <th style="width:50px;">인원</th>
              <th style="width:100px;"><span class="text-danger">*</span>행사기간</th>
              <th style="width:70px;">출발도시</th>
              <th style="width:70px;">여행지</th>
              <th style="width:80px;"><span class="text-danger">*</span>진행담당</th>
              <th style="width:150px;">비고사항</th>
              <th style="width:50px;"></th>
            </tr>
          </thead>
          <tbody class="small">
            <tr>
              <td>
                <select class="form-select form-select-sm resize-select" v-model="this.dealInfoDetail.reqStatus" ref="reqStatus">
                  <option :value="r.procCode" :key="i" v-for="(r,i) in this.reqStatusInfo">{{ r.procName }}</option>
                </select>
                <p mt-3 class="text-danger" v-if="this.dealInfoDetail.reqStatus === 'SE'">
                  {{ this.getDateFormat(this.dealInfoDetail.dSetDate) }}
                </p>
              </td>
              <td>
                <input type="text"  class="text-success mb-1 resize-input" v-model="this.dealInfoDetail.dealNameKor" maxlength="70" ref="dealNameKor" placeholder="국문,최대70자">
                <input type="text" class="mb-1 resize-input" v-model="this.dealInfoDetail.dealNameEng" maxlength="100" ref="dealNameEng" placeholder="영문,최대100자">
              </td>

              <td v-if="this.newDealFlag === 'Y'">
                <p class="mt-2 text-danger text-center fw-bold">
                  {{ this.getCurrencyFormat(this.dealInfoDetail.saleAmt) }} 원
                </p>
              </td>
              <td v-else>
                <input type="text" v-model="this.dealInfoDetail.dealPrice_tot" maxlength="12" ref="dealPrice_tot" placeholder="숫자만" class="resize-input">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(this.dealInfoDetail.dealPrice_tot) }} 원
                </p>
              </td>

              <td>
                <input type="text" v-model="this.dealInfoDetail.reqName" maxlength="30" ref="reqName" class="resize-input">
              </td>
              <td>
                <div class="mb-1">
                  <input type="text" v-model="this.dealInfoDetail.reqTelNo" size="10" maxlength="15" ref="reqTelNo" placeholder="전화(숫자만)" class="resize-input">
                </div>
                <div>
                  <input type="text" v-model="this.dealInfoDetail.reqEmail" size="16" maxlength="50" ref="reqEmail" placeholder="이메일" class="resize-input">
                </div>
              </td>

              <td v-if="this.newDealFlag === 'Y'">
                <span class="text-danger fw-bold">
                  {{ this.getCurrencyFormat(this.dealInfoDetail.paxCnt) }}
                </span>
              </td>
              <td v-else>
                <input type="text" v-model="this.dealInfoDetail.paxCnt" maxlength="6" ref="paxCnt" placeholder="숫자만" class="resize-input text-center">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(this.dealInfoDetail.paxCnt) }}
                </p>
              </td>
              
              <td>
                <div class="input-group mb-1">
                  <span class="input-group-text input-group-sm" id="basic-addon1" style="font-size:smaller">시작</span>
                  <input type="date" class="form-control form-control-sm" ref="evtStartDate" v-model="this.dealInfoDetail.evtStartDate" style="font-size:smaller">
                </div>
                <div class="input-group">
                  <span class="input-group-text input-group-sm" id="basic-addon1" style="font-size:smaller">종료</span>
                  <input type="date" class="form-control form-controm-sm" ref="evtCloseDate" v-model="this.dealInfoDetail.evtCloseDate" style="font-size:smaller">
                </div>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="this.dealInfoDetail.dptCtCode" style="font-size: smaller;" ref="dptCtCode">
                  <option :value="d.baseCode" :key="i" v-for="(d,i) in this.dptCtList">{{ d.codeNameKor }}</option>
                </select>
              </td>
              <td>
                <div class="mb-1">
                  <select class="form-select form-select-sm" v-model="this.dealInfoDetail.ntCd" style="font-size: smaller;" @change="changeNationList(this.dealInfoDetail.ntCd)" ref="ntCd">
                    <option :value="c.baseCode" :key="i" v-for="(c,i) in this.tripNtList">{{ c.codeNameKor }}</option>
                  </select>
                </div>
                <div>
                  <select class="form-select form-select-sm" v-model="this.dealInfoDetail.arCd" style="font-size: smaller;" ref="arCd">
                    <option :value="a.baseCode" :key="i" v-for="(a,i) in this.tripArList">{{ a.codeNameKor }}</option>
                  </select>
                </div>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="this.dealInfoDetail.dealChargeId" style="font-size: smaller;" ref="dealChargeId">
                  <option :value="p.handlerId" :key="i" v-for="(p,i) in this.chargePList">{{ p.handlerNameKor }}</option>
                </select>
              </td>
              <td>
                <textarea class="form-control resize-input" placeholder="1,000자 이내" ref="evRemarks" v-model="this.dealInfoDetail.evRemarks" maxlength="1000" style="height: 80px;"></textarea>
              </td>
              <td v-if="this.changePermission === 'N'">
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="updateEvent(this.dealInfoDetail.dealCode)" disabled>변경</button>
                <p class="mt-1">
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="cancelEvent(this.dealInfoDetail.dealCode)" disabled>취소</button>
                </p>
                <p v-if="this.user.handlerGrade < 6">
                  <button type="button" class="btn btn-outline-warning btn-sm" @click="cancelSE(this.dealInfoDetail.dealCode)" >정산취소</button>
                </p>
              </td>
              <td v-else>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="updateEvent(this.dealInfoDetail.dealCode)">변경</button>
                <p class="mt-1">
                  <button type="button" class="btn btn-outline-danger btn-sm" @click="cancelEvent(this.dealInfoDetail.dealCode)">취소</button>
                </p>
              </td>
            </tr>
          </tbody>
          <br>
          <br>
        </table>

        <!-- 판매현황 (신정산 전용) -->
        <div class="text-dark text-start fs-6 mb-2 section-title" v-if="this.newDealFlag === 'Y'">
          <b>[ &nbsp; 판매현황 &nbsp; ]</b>
        </div>
        <table class="table table-bordered summary-table mb-3" v-if="this.newDealFlag === 'Y'">
          <tr>
            <th>①판매액</th>
            <th>②판매수수료</th>
            <th>③정산액(①-②)</th>
          </tr>
          <tr>
            <td class="text-danger">{{ this.getCurrencyFormat(this.salesPriceTotal) }}</td>
            <td class="text-primary">{{ this.getCurrencyFormat(this.salesFeeTotal) }}</td>
            <td class="text-success">{{ this.getCurrencyFormat(this.salesTotalAmt) }}</td>
          </tr>
          <tr>
            <th>④입금액</th>
            <th>미수/과입(③-④)</th>
            <th>⑤지출액</th>
          </tr>
          <tr>
            <td>{{ this.getCurrencyFormat(this.sumOfConvMoney) }}</td>
            <td :class="this.netUnpaidOverpaidAmt > 0 ? 'text-danger' : (this.netUnpaidOverpaidAmt < 0 ? 'text-primary' : '')">
                {{ this.getCurrencyFormat(Math.abs(this.netUnpaidOverpaidAmt)) }}
                <span v-if="this.netUnpaidOverpaidAmt !== 0" class="summary-sub">{{ this.netUnpaidOverpaidLabel }}</span>
            </td>
            <td>{{ this.getCurrencyFormat(this.expTotal) }}</td>
          </tr>
          <tr>
            <th>⑥알선수수료(④-⑤)</th>
            <th>⑦공급가액(⑥-⑧)</th>
            <th>⑧부가세</th>
          </tr>
          <tr>
            <td>{{ this.getCurrencyFormat(this.preVatProfitAmt) }}</td>
            <td>{{ this.getCurrencyFormat(this.brokerageAmt) }}</td>
            <td>{{ this.getCurrencyFormat(this.vatAmt) }}</td>
          </tr>
          <tr>
            <th>1인당수익(⑦/인원)</th>
            <th>행사수익률</th>
            <th></th>
          </tr>
          <tr>
            <td>{{ this.getCurrencyFormat(this.profitPerPax) }}</td>
            <td>{{ this.profitRate.toFixed(1) }} %</td>
            <td></td>
          </tr>
        </table>

        <!-- 미수금 입력처리 -->
        <div class="text-end mb-1" v-if="this.newDealFlag !== 'Y'">
          <button type="button" class="btn btn-secondary btn-sm" @click="showRegitDeposit('D');">
            <i class="bi bi-caret-down"></i> 미수내역입력
          </button>
        </div>

        <div class="text-primary text-start fs-6 section-title" v-if="this.createDFlag == 'Y' && this.newDealFlag !== 'Y'">
          <b>[ &nbsp; 미수금 정보등록 &nbsp; <span style="font-size: smaller; color:red">※ 환율과 수수율을 입력하지 않는 경우, 기본율이 적용되며, 기초정보가 없는 경우 1로 계산됩니다</span> ]</b>
        </div>
        <table class="table table-bordered table-striped fs-6" v-if="this.createDFlag == 'Y' && this.newDealFlag !== 'Y'">
          <thead class="small">
            <tr>
              <th style="width:120px;"><span class="text-danger">*</span>미수내역</th>
              <th style="width:90px;"><span class="text-danger">*</span>미수액</th>
              <th style="width:50px;"><span class="text-danger">*</span>통화</th>
              <th style="width:50px;"><span class="text-danger">*</span>환율</th>
              <th style="width:80px;"><span class="text-danger">*</span>결제수단</th>
              <th style="width:90px;"><span class="text-danger">*</span>결제루트</th>
              <th style="width:50px;"><span class="text-danger">*</span>수수율</th>
              <th style="width:70px;"><span class="text-danger">*</span>미입금자/거래처</th>
              <th style="width:70px;"><span class="text-danger">*</span>미수일자</th>
              <th style="width:150px;">비고사항</th>
              <th style="width:50px;">-</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr>
              <td>
                <input type="text"  class="text-success mb-1 resize-input" v-model="this.dDealDetail" maxlength="200" ref="reg_dDealDetail" placeholder="최대200자">
              </td>
              <td>
                <input type="text" v-model="this.dPrice" maxlength="10" ref="reg_dPrice" placeholder="숫자만" class="resize-input">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(this.dPrice) }}
                </p>
              </td>
              <td>
                <select class="form-select form-select-sm resize-select" v-model="this.dCurCd" style="font-size: smaller;" ref="reg_dCurCd" @change="getExRate('D',this.dCurCd)">
                  <option :value="r.fCodeNo" :key="i" v-for="(r,i) in this.finCode_curr">{{ r.fName }}</option>
                </select>
              </td>
              <td>
                <input type="text" v-model="this.dExRate" maxlength="10" ref="reg_dExRate" placeholder="소숫점2자리까지" class="resize-input">
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="this.dPayMethod" style="font-size: smaller;" ref="reg_dPayMethod" @change="changePaymethod('C',this.dPayMethod,'')">
                  <option :value="r.baseCode" :key="i" v-for="(r,i) in this.payMethodList">{{ r.codeNameKor }}</option>
                </select>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="this.dPayCode" style="font-size: smaller;" ref="reg_dPayCode" @change="getFeeRate(this.dPayCode,'D')">
                  <option :value="p.fCodeNo" :key="i" v-for="(p,i) in this.payCodeList">{{ p.fName }}</option>
                </select>
              </td>
              <td>
                <input type="text" v-model="this.dFeeRate" maxlength="10" ref="reg_dFeeRate" placeholder="소숫점2자리까지" class="resize-input">
              </td>
              <td>
                <input type="text" v-model="this.dDepositor" maxlength="15" ref="reg_dDepositor" class="resize-input">
                <p class="mt-1">
                  <select class="form-select form-select-sm" v-model="this.dPartnerCd" style="font-size: smaller;">
                    <option value="not" selected>해당없음</option>
                    <option :value="p.pName" :key="i" v-for="(p,i) in this.partnerInfo">{{ p.pName }}</option>
                  </select>
                </p>
              </td>
              <td>
                <input type="date" class="form-control form-control-sm" ref="reg_dDate" v-model="this.dDate" style="font-size:smaller">
              </td>
              <td>
                <textarea class="form-control resize-input" placeholder="300자 이내" ref="reg_dDetailRemarks" v-model="this.dDetailRemarks" maxlength="300"></textarea>
              </td>
              <td>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="registDeposit(this.dealInfoDetail.dealCode, 'O')">등록</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="align-middle fs-4 mb-2">
          <i class="bi bi-arrow-down-square-fill text-secondary"  v-if="this.createDFlag == 'Y' && this.newDealFlag !== 'Y'"></i>
        </div>


        <!-- 판매내역 입력처리 -->
        <div class="text-end mb-1 d-flex justify-content-end gap-2" v-if="this.newDealFlag === 'Y'">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="downloadSaleTemplate()">
            <i class="bi bi-download"></i> 엑셀양식
          </button>
          <button type="button" class="btn btn-outline-success btn-sm"
                  @click="triggerSaleExcelUpload()"
                  v-if="this.canRegisterSale"
                  :disabled="isUploading">
            <i class="bi bi-upload"></i> {{ isUploading ? '처리중...' : '엑셀 일괄등록(최대300건)' }}
          </button>
          <input type="file" ref="saleExcelInput" accept=".xlsx,.xls" style="display:none" @change="handleSaleExcelUpload">
          <button type="button" class="btn btn-info btn-sm" @click="showRegitDeposit('S');" v-if="this.canRegisterSale">
            <i class="bi bi-caret-down"></i> 판매내역등록
          </button>
        </div>

        <div v-if="this.createSFlag === 'Y'" class="mb-5">
          <table class="table table-bordered fs-6">
            <thead class="small">
              <tr style="background-color: rgb(172, 213, 172);">
                <th style="width:10%;"><span class="text-danger">*</span>고객명</th>
                <th style="width:10%;"><span class="text-danger">*</span>인원</th>
                <th style="width:10%;"><span class="text-danger">*</span>①판매가</th>
                <th style="width:8%;" >②판매수수료</th>
                <th style="width:12%;">③(①-②)총판매가</th>
                <th style="width:15%;"><span class="text-danger">*</span>판매수단</th>
                <th style="width:10%;">수단예번</th>
                <th style="width:26%;">메모사항</th>
                <th style="width:4%;" >-</th>
              </tr>
            </thead>
            <tbody class="small">
              <tr>
                <td>
                  <input type="text" v-model="this.sa_cusName" maxlength="50" ref="sa_cusName" placeholder="50자까지" class="resize-input">
                </td>
                <td>
                  <!-- 판매내역등록 폼의 인원 input -->
                  <input type="number" v-model="this.sa_cusCnt" min="0" max="9999" ref="sa_cusCnt" class="resize-input"
                        :disabled="sa_channelCode.toUpperCase() === 'TAX'"
                        :title="sa_channelCode.toUpperCase() === 'TAX' ? 'TAX건은 인원이 집계되지 않습니다.' : ''">
                </td>
                <td>
                  <input type="number" v-model="this.sa_dSalePrice" min="0" ref="sa_dSalePrice" class="resize-input">
                  <p class="mt-2 text-secondary text-sm-end">
                    {{ this.getCurrencyFormat(this.sa_dSalePrice) }}
                  </p>
                </td>
                <td>
                  <input type="number" v-model="this.sa_dSaleFee" min="0" ref="sa_saleFee" class="resize-input">
                  <p class="mt-2 text-secondary text-sm-end">
                    {{ this.getCurrencyFormat(this.sa_dSaleFee) }}
                  </p>
                </td>
                <td style="color:deeppink; font-size:1rem;">{{ this.getCurrencyFormat(this.sa_dSalePrice-this.sa_dSaleFee) }}</td>
                <td style="position: relative;">
                  <input type="text" v-model="sa_channelKeyword" @input="searchSaleChannel"
                         @keydown.enter.prevent="confirmChannelInput" @blur="confirmChannelInput"
                         placeholder="판매수단 검색" class="resize-input" ref="channelCode" autocomplete="off">

                  <div class="autocomplete" v-if="sa_channelSearchResult.length > 0">
                    <div class="text-start" style="cursor:pointer" :key="i" v-for="(sch,i) in sa_channelSearchResult" @mousedown="selectSaleChannel(sch)">
                      [{{ sch.pCode }}] {{ sch.pName }}
                    </div>
                  </div>
                </td>
                <td>
                  <!-- 컬럼(sa_dSaleChResCode varchar(40))에 맞춰 50 → 40 -->
                  <input type="text" v-model="this.sa_channelResCode" maxlength="40" ref="channelResCode" class="resize-input">
                </td>                
                <td>
                  <textarea class="form-control resize-input" placeholder="300자 이내" ref="sa_dSaleMemo" v-model="this.sa_dSaleMemo" maxlength="300"></textarea>
                </td>
                <td>
                  <button type="button" class="btn btn-outline-success btn-sm" @click="registDeposit(this.dealCode, 'SA')">등록</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 판매내역리스트 -->
        <div class="text-info text-start fs-6 section-title" id="sales" v-if="this.newDealFlag === 'Y'">
          <b>[ &nbsp; 판매내역 &nbsp;]</b>
          <span class="text-dark fst-italic">
            &nbsp;총액: {{ this.getCurrencyFormat(this.salesTotalAmt) }}원 &nbsp;/&nbsp;
            미수: <span :class="this.salesUnpaidAmt < 0 ? 'text-danger fw-bold' : 'text-dark'">{{ this.getCurrencyFormat(Math.abs(this.salesUnpaidAmt)) }}원</span> &nbsp;/&nbsp;
            과입: <span :class="this.salesOverpaidAmt > 0 ? 'text-primary fw-bold' : 'text-dark'">{{ this.getCurrencyFormat(this.salesOverpaidAmt) }}원</span>
          </span>&nbsp;&nbsp;

          <a href="#deposit" class="btn btn-outline-primary btn-sm" style="font-size: 0.7rem;"> → 입금내역으로</a>&nbsp;&nbsp;
          <a href="#withdrawal" class="btn btn-outline-success btn-sm" style="font-size: 0.7rem;"> → 지출내역으로</a>

          <span class="channel-summary-trigger" v-if="salesByChannel.length > 0">
            수단별 합계 <i class="bi bi-info-circle"></i>
            <div class="channel-summary-layer">
              <table class="channel-summary-table">
                <thead>
                  <tr><th>판매수단</th><th class="text-end">건수</th><th class="text-end">총판매가</th></tr>
                </thead>
                <tbody>
                  <tr :key="c.channelCode" v-for="c in salesByChannel">
                    <td class="text-start">{{ c.channelName }}</td>
                    <td class="text-end">{{ c.cnt }}</td>
                    <td class="text-end">{{ getCurrencyFormat(c.totalAmt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </span>
        </div>
        <table class="table table-bordered table-striped fs-6" v-if="this.newDealFlag === 'Y'">
          <thead class="small">
            <tr>
              <th style="width:3%;" >번호</th>
              <th style="width:10%;"><span class="text-danger">*</span>고객명</th>
              <th style="width:10%;">수단명</th>
              <th style="width:4%;" ><span class="text-danger">*</span>인원</th>
              <th style="width:8%;" ><span class="text-danger">*</span>①판매가</th>
              <th style="width:8%;" ><span class="text-danger">*</span>②판매수수료</th>
              <th style="width:9%;" ><span class="text-danger">*</span>③(①-②)총판매가</th>
              <th style="width:9%;" >④입금액</th>
              <th style="width:8%;" >③-④미수/과입</th>
              <th style="width:15%;">메모사항</th> 
              <th style="width:6%;" >-</th>
            </tr>
          </thead>
          <tbody class="small">
            <template :key="sh.sa_dSubNo" v-for="(sh, s) in this.sortedSalesHistoryInfo">
              <tr :id="'sale-row-' + sh.sa_dSubNo" :class="{'row-highlight': highlightedSubNo === sh.sa_dSubNo}">
                <td>{{ s+1 }}</td>
                <td>
                  <span class="badge bg-success me-1">#{{ s+1 }}</span>
                  <input type="text" v-model="sh.sa_cusName" maxlength="50" ref="sa_cusName" placeholder="50자까지" class="resize-input">
                </td>
                <td>
                  {{ sh.pName }} ({{ sh.sa_dSaleChCode }})
                </td>
                <td>
                  <input type="number" v-model="sh.sa_cusCnt" min="0" max="9999" ref="sa_cusCnt" class="resize-input"
                        :disabled="sh.sa_dSaleChCode === 'TAX'"
                        :title="sh.sa_dSaleChCode === 'TAX' ? 'TAX건은 인원이 집계되지 않습니다.' : ''">
                </td>
                <td>
                  <input type="number" v-model="sh.sa_dSalePrice" min="0" ref="sa_dSalePrice" class="resize-input">
                  <p class="mt-2 text-secondary text-sm-end">
                    {{ this.getCurrencyFormat(sh.sa_dSalePrice) }}
                  </p>
                </td>
                <td>
                  <input type="number" v-model="sh.sa_dSaleFee" min="0" ref="sa_dSaleFee" class="resize-input">
                  <p class="mt-2 text-secondary text-sm-end">
                    {{ this.getCurrencyFormat(sh.sa_dSaleFee) }}
                  </p>
                </td>
                <td class="text-danger fw-bold">
                  {{ this.getCurrencyFormat(sh.sa_dSalePrice-sh.sa_dSaleFee) }}
                </td>

                <td>{{ this.getCurrencyFormat(sh.sa_payAmt) }}</td>

                <td :class="{'text-danger': (sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) > 0, 'text-primary' : (sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) < 0}">
                  {{ this.getCurrencyFormat(Math.abs(sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt)) }}
                  <span v-if="(sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) !== 0" style="font-size:0.65rem; color:#868686;">
                    {{ (sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) > 0 ? '(미수)' : '(과입)' }}
                  </span>
                </td>

                <td>
                  <textarea class="form-control resize-input" placeholder="300자 이내" ref="sa_dSaleMemo" v-model="sh.sa_dSaleMemo" maxlength="300"></textarea>
                </td>
                <td>
                  <span :title="(sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) === 0 ? '이미 전액 입금처리된 판매건입니다.' : ''">
                    <button type="button" class="btn btn-outline-info btn-sm m-1" @click="openDepositSearch(sh)"
                      :disabled="(sh.sa_dSalePrice - sh.sa_dSaleFee - sh.sa_payAmt) === 0">입금</button>
                  </span>

                  <span :title="sh.sa_payAmt > 0 ? '입금이 있는 판매건은 변경할 수 없습니다. 먼저 입금을 취소해주세요.' : ''">
                    <button type="button" class="btn btn-outline-success btn-sm m-1" @click="changeDeposit(this.dealCode, sh.sa_dSubNo, s, 'SA')"
                      :disabled="sh.sa_payAmt > 0"
                      v-if="this.canRegisterSale">변경</button>
                  </span>

                  <span :title="sh.sa_payAmt > 0 ? '입금이 있는 판매건입니다. 삭제 시 매칭된 입금도 함께 취소처리됩니다.' : ''">
                    <button type="button" class="btn btn-outline-danger btn-sm m-1" @click="excludeDeposit(this.dealCode, sh.sa_dSubNo, s, 'SA', '')" v-if="this.canRegisterSale">삭제</button>
                  </span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <hr class="mt-5 mb-5">

        <div class="text-primary text-start fs-6 mb-2 section-title" id="deposit">
          <b>[ &nbsp; 입금내역 &nbsp; ]</b>&nbsp;&nbsp;&nbsp; <i style="font-size: small; color:gray">총액: <b>{{ this.getCurrencyFormat(this.sumOfConvMoney) }}</b> 원</i>&nbsp;&nbsp;&nbsp;
          <a href="#sales" class="btn btn-outline-info btn-sm" style="font-size: 0.7rem;"> → 판매내역으로</a>&nbsp;&nbsp;
          <a href="#withdrawal" class="btn btn-outline-success btn-sm" style="font-size: 0.7rem;"> → 지출내역으로</a>
        </div>

        <!-- 신정산: 읽기전용 입금내역 -->
        <!-- 뱃지 색상은 depositCodeMeta의 badge(진한색)/bg(연한 배경)를 그대로 재사용해서
          같은 exDepositNo(같은 입금건) 그룹끼리 색이 통일되도록 함.
          입금코드 칸의 그룹번호 뱃지는 배경색과 역할이 겹쳐 제거하고, 짧은코드+툴팁만 남김. -->
        <table class="table table-bordered table-striped fs-6" v-if="this.newDealFlag === 'Y'">
          <thead class="small">
            <tr>
              <th style="width:5%;">번호</th>
              <th style="width:13%;">입금코드</th>
              <th style="width:9%;">입금자</th>
              <th style="width:9%;">고객명</th>
              <th style="width:9%;">입금액</th>
              <th style="width:9%;">결제수단</th>
              <th style="width:7%;">처리자</th>
              <th style="width:9%;">수단명</th>
              <th style="width:16%;">비고</th>
              <th style="width:10%;">처리</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr :key="j" v-for="(d, j) in this.dDepositInfo"
                :style="{ backgroundColor: depositCodeMeta[d.exDepositNo] ? depositCodeMeta[d.exDepositNo].bg : 'transparent' }">
              <td>{{ j+1 }}</td>
              <td>
                <a @click="goToSuppliment_detail(d.exDepositNo)" style="cursor:pointer; font-size: smaller;" class="text-primary">{{ d.exDepositNo }}</a>
              </td>
              <td>{{ d.payDepositor }}</td>
              <td>
                <span
                  v-if="d.sa_dSubNo && saleSubNoDisplayMap[d.sa_dSubNo]"
                  class="badge me-1"
                  :style="{ backgroundColor: depositCodeMeta[d.exDepositNo] ? depositCodeMeta[d.exDepositNo].badge : '#999', color: '#fff', cursor: 'pointer' }"
                  @click="scrollToSaleRow(d.sa_dSubNo)"
                  title="판매내역으로 이동"
                >#{{ saleSubNoDisplayMap[d.sa_dSubNo] }}</span>
                {{ d.sa_cusName }}
              </td>
              <td class="fw-bold" :class="d.payCxlId ? 'text-danger' : 'text-primary'">
                {{ this.getCurrencyFormat(d.payAmt) }}
                <span v-if="d.payCxlId" style="font-size:smaller;">(취소)</span>
              </td>
              <td>{{ this.getPayMethodName(d.payMethod) }}</td>
              <td>{{ d.payCxlId ? d.cxlHandlerName : d.payHandlerName }}</td>
              <td>{{ d.channelName }}</td>
              <td>{{ d.payRemarks }}</td>
              <td>
                <button type="button" class="btn btn-outline-danger btn-sm"
                  @click="cancelDepositPay(d)"
                  :disabled="!!d.payCxlId || !d.sa_dSubNo"
                  :title="d.payCxlId ? '이미 취소된 내역입니다.' : (!d.sa_dSubNo ? '판매건과 연결되지 않아 취소할 수 없습니다.' : '')">취소</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 구정산 수동입력형 입금내역 -->
        <table class="table table-bordered table-striped fs-6" v-else>
          <thead class="small">
            <tr>
              <th style="width:8px;"><span class="text-danger"></span></th>
              <th style="width:120px;"><span class="text-danger">*</span>거래내역</th>
              <th style="width:90px;"><span class="text-danger">*</span>입금액</th>
              <th style="width:50px;"><span class="text-danger">*</span>통화/환율</th>
              <th style="width:80px;"><span class="text-danger">*</span>결제수단</th>
              <th style="width:50px;"><span class="text-danger">*</span>수수율</th>
              <th style="width:70px;"><span class="text-danger">*</span>입금자/거래처</th>
              <th style="width:70px;"><span class="text-danger">*</span>입금일자</th>
              <th style="width:50px;">환산(원)</th>
              <th style="width:50px;">미수(원)</th>
              <th style="width:50px;"><span class="text-danger">*</span>처리자</th>
              <th style="width:150px;">비고사항</th>
              <th style="width:50px;">-</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr :key="j" v-for="(d, j) in this.dDepositInfo">
              <td>{{ j+1 }}</td>
              <td>
                <input type="text"  class="text-success mb-1 resize-input" v-model="d.dDealDetail" maxlength="200" ref="dDealDetail" placeholder="최대200자">
                <p class="mt-1" style="font-size: smaller; color:blue; cursor: pointer;">
                  <a @click="goToSuppliment_detail(d.exDepositNo)" style="cursor:pointer" class="text-blue">{{ d.exDepositNo }}</a>
                </p>
                <p v-if="d.outStFlag === 'Y'" style="color:red; font-weight:600;">
                  미수금액
                </p>
              </td>
              <td>
                <input type="text" v-model="d.dPrice" maxlength="10" ref="dPrice" placeholder="숫자만" class="resize-input">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(d.dPrice) }}
                </p>
              </td>
              <td>
                <select class="form-select form-select-sm resize-select" v-model="d.dCurCd" style="font-size: smaller;" ref="dCurCd" @change="getExRate1(d.dCurCd, j, 'D')">
                  <option :value="r.fCodeNo" :key="i" v-for="(r,i) in this.finCode_currB">{{ r.fName }}</option>
                </select>
                <p class="mt-1">
                  <input type="text" v-model="d.dExRate" maxlength="10" ref="dExRate" placeholder="소숫점2자리까지" class="resize-input">
                </p>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="d.dPayMethod" style="font-size: smaller;" ref="dPayMethod" @change="changePaymethod('R',d.dPayMethod,j)">
                  <option :value="r.baseCode" :key="i" v-for="(r,i) in this.payMethodListB">{{ r.codeNameKor }}</option>
                </select>
                <p class="mt-1">
                  <select class="form-select form-select-sm" v-model="d.dPayCode" style="font-size: smaller;" ref="dPayCode" @change="getFeeRate1(d.dPayCode, j, 'D')">
                    <option :value="d.dPayCode" disabled v-if="this.payCodeListB[j] == undefined">{{ d.finName }}</option>
                    <option :value="p.fCodeNo" :key="i" v-for="(p,i) in this.payCodeListB[j]">{{ p.fName }}</option>
                  </select>
                </p>
              </td>
              <td>
                <input type="text" v-model="d.dFeeRate" maxlength="10" ref="dFeeRate" placeholder="소숫점2자리까지" class="resize-input">
              </td>
              <td>
                <input type="text" v-model="d.dDepositor" maxlength="15" ref="dDepositor" class="resize-input">
                <p class="mt-1">
                  <select class="form-select form-select-sm" v-model="d.dPartnerCd" style="font-size: smaller;">
                    <option value="not" selected>해당없음</option>
                    <option v-show="p.pCode != 'ZETW'" :value="p.pCode" :key="i" v-for="(p,i) in this.partnerInfo">{{ p.pName }}</option>
                  </select>
                </p>
              </td>
              <td>
                <input type="date" class="form-control form-control-sm" ref="dDate" v-model="d.dDate" style="font-size:smaller">
              </td>
              <td>
                <div>
                  <b v-if="d.outStFlag === 'Y'" class="text-danger">{{ this.getCurrencyFormat(d.dConvMoney) }}</b>
                  <b v-else class="text-primary">{{ this.getCurrencyFormat(d.dConvMoney) }}</b>
                  <p style="font-size: smaller; color:gray">(수수율 불포함)</p>
                </div>
              </td>
              <td>
                <div style="color:grey">
                  {{ this.getCurrencyFormat(d.dCalBalance) }}
                </div>
              </td>
              <td>
                {{ d.handler }}
              </td>
              <td>
                <textarea class="form-control resize-input" placeholder="300자 이내" ref="dDetailRemarks" v-model="d.dDetailRemarks" maxlength="300" style="height: 95px;"></textarea>
              </td>

              <td v-if="d.cFlag === 'Y'">
                <div class="text-danger">마감</div>
              </td>
              <td v-else>
                <div v-if="d.dFixFlag === 'Y'">
                  <button type="button" class="btn btn-outline-secondary btn-sm m-1" @click="nAlert()">변경</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm m-1" @click="nAlert()">삭제</button>
                  <button type="button" class="btn btn-outline-danger btn-sm m-1" @click="excludeDeposit(this.dealInfoDetail.dealCode, d.dSubNo,j, 'D', d.exDepositNo)" v-if="this.dealInfoDetail.reqStatus != 'SE'">삭제{{ d.reqStatus }}</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm m-1" v-if="d.outStFlag === 'Y'"  @click="nAlert()">미수삭제</button>
                </div>
                <div v-else>
                  <button type="button" class="btn btn-outline-success btn-sm m-1" @click="changeDeposit(this.dealInfoDetail.dealCode, d.dSubNo, j, 'D')" v-if="this.user.handlerGrade < 6">변경</button>
                  <button type="button" class="btn btn-outline-danger btn-sm m-1" @click="excludeDeposit(this.dealInfoDetail.dealCode, d.dSubNo,j, 'D', d.exDepositNo)" v-if="this.dealInfoDetail.reqStatus != 'SE'">삭제{{ d.reqStatus }}</button>
                  <button type="button" class="btn btn-secondary btn-sm m-1" v-if="d.outStFlag === 'Y'"  @click="excludeOutSt(d.dSubNo)">미수삭제</button>
                </div>
              </td>
            </tr>
          </tbody>
          <br>
          <br>
        </table>


        <div class="text-end mb-1" v-if="this.dealInfoDetail.reqStatus != 'SE'">
          <button type="button" class="btn btn-secondary btn-sm" @click="showRegitDeposit('W');">
            <i class="bi bi-caret-down"></i> 지출처리
          </button>
        </div>
        <div class="text-primary text-start fs-6 section-title" v-if="this.createWFlag == 'Y'">
          <b>[ &nbsp; 지출정보등록 &nbsp; <span style="font-size: smaller; color:red">※ 환율과 수수율을 입력하지 않는 경우, 기본율이 적용되며, 기초정보가 없는 경우 1로 계산됩니다</span> ]</b>
        </div>
        <table class="table table-bordered table-striped fs-6" v-if="this.createWFlag == 'Y'">
          <thead class="small">
            <tr>
              <th style="width:6%;"><span class="text-danger">*</span>지출분류</th>
              <th style="width:12%;"><span class="text-danger">*</span>지출항목</th>
              <th style="width:10%;"><span class="text-danger">*</span>거래처</th>
              <th style="width:5%;"><span class="text-danger">*</span>지출일자</th>
              <th style="width:6%;"><span class="text-danger">*</span>지출액</th>
              <th style="width:6%;"><span class="text-danger">*</span>통화/환율</th>
              <th style="width:6%;"><span class="text-danger">*</span>지출수단/수수율</th>
              <th style="width:10%;">환산액</th>
              <th style="width:5%;"><span class="text-danger">*</span>수량</th>
              <th style="width:10%;">합계액</th>
              <th style="width:10%;">계좌정보</th>
              <th style="width:10%;">비고사항</th>
              <th style="width:5%;">-</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr>
              <td>
                <select class="form-select form-select-sm resize-select" v-model="this.expCatCode" style="font-size: smaller;" ref="reg_expCatCode" @change="changeExpCatCode(this.expCatCode)">
                  <option :value="ep.procCode" :key="i" v-for="(ep,i) in this.expCatList">{{ ep.procName }}</option>
                </select>
              </td>
              <td>
                <select class="form-select form-select-sm resize-select" v-model="this.expCode" style="font-size: smaller;" ref="reg_expCode">
                  <option :value="ei.expCode" :key="i" v-for="(ei,i) in this.expInfo">{{ ei.expName }}</option>
                </select>
              </td>
              <td style="position: relative;">
                <input type="text" v-model="expPartnerKeyword" @input="searchExpPartner"
                      @keydown.enter.prevent="confirmExpPartnerInput" @blur="confirmExpPartnerInput"
                      placeholder="거래처 검색" class="resize-input" ref="reg_expPartnerCd" autocomplete="off">

                <div class="autocomplete" v-if="expPartnerSearchResult.length > 0">
                  <div class="text-start" style="cursor:pointer" :key="i" v-for="(p,i) in expPartnerSearchResult" @mousedown="selectExpPartner(p)">
                    [{{ p.pCode }}] {{ p.pName }}
                  </div>
                </div>

                <p class="mt-1"  v-if="this.expPartnerCd === 'ZETW'">
                  <input type="text" v-model="this.exPartnerName" maxlength="15" ref="reg_exPartnerName" class="resize-input" placeholder="명칭">
                  <input type="text" v-model="this.exPartnerTel" maxlength="15" ref="reg_exPartnerTel" class="resize-input" placeholder="연락처(숫자만)">
                </p>
              </td>
              <td>
                <input type="date" class="form-control form-control-sm" ref="reg_expDate" v-model="this.expDate" style="font-size:smaller">
              </td>
              <td>
                <input type="text" v-model="this.expAmt" maxlength="10" ref="reg_expAmt" placeholder="숫자만" class="resize-input">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(this.expAmt) }}
                </p>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="this.expCurCd" style="font-size: smaller;" ref="reg_expCurCd" @change="getExRate('W',this.expCurCd)">
                  <option :value="c.fCodeNo" :key="i" v-for="(c,i) in this.finCode_curr">{{ c.fName }}</option>
                </select>
                <p class="mt-1">
                  <input type="text" v-model="this.expExRate" maxlength="10" ref="reg_expExRate" placeholder="소숫점2자리까지" class="resize-input">
                </p>
              </td>

              <td>
                <select class="form-select form-select-sm" v-model="this.expPayMethod" style="font-size: smaller;" ref="reg_expPayMethod" @change="changePaymethod('C',this.expPayMethod,'')">
                  <option :value="r.baseCode" :key="i" v-for="(r,i) in this.payMethodList">{{ r.codeNameKor }}</option>
                </select>
                <p class="mt-1 mb-1">
                  <select class="form-select form-select-sm" v-model="this.expPayCode" style="font-size: smaller;" ref="reg_expPayCode" @change="getFeeRate(this.expPayCode, 'W')">
                    <option :value="p.fCodeNo" :key="i" v-for="(p,i) in this.payCodeList">{{ p.fName }}</option>
                  </select>
                </p>
                <p class="mt-0 mb-0">
                  <input type="text" v-model="this.expFeeRate" maxlength="10" ref="reg_expFeeRate" placeholder="소숫점2자리까지" class="resize-input">
                </p>
              </td>
              
              <td>
                <input type="hidden" v-model="this.expConvMoney" maxlength="10" ref="reg_expConvMoney" class="resize-input">
                <p class="mt-1 text-secondary text-end">
                  {{ this.getCurrencyFormat(this.expConvMoney) }}원
                  <br>
                  <span style="font-size: smaller; color:gray">(수수율 불포함)</span>
                </p>
              </td>
              <td>
                <input type="text" v-model="this.expQty" maxlength="10" ref="reg_expQty" class="resize-input">
              </td>
              <td>
                <b class="text-danger">{{ this.getCurrencyFormat((this.expConvMoney*1)*(this.expQty*1))}}</b> 원
              </td>

              <td>
                <select class="form-select form-select-sm" v-model="bankCode" style="font-size: smaller;" ref="bankCode">
                  <option :value="c.fCodeNo" :key="i" v-for="(c,i) in this.bankInfo">{{ c.fName }}</option>
                </select>
                <p class="mt-1 mb-1">
                  <input type="text" v-model="bAccount" maxlength="30" ref="bAccount" placeholder="계좌번호" class="resize-input">
                </p>
                <p class="mt-0 mb-0">
                  <input type="text" v-model="accHolder" maxlength="50" ref="accHolder" placeholder="예금주" class="resize-input" style="background-color: blanchedalmond;">
                </p>
              </td>

              <td>
                <textarea class="form-control resize-input" placeholder="300자 이내" ref="reg_dDetailRemarks" v-model="this.expRemarks" maxlength="300" style="height: 80px;"></textarea>
              </td>
              <td>
                <button type="button" class="btn btn-outline-primary btn-sm" @click="registDeposit(this.dealInfoDetail.dealCode, 'W')">지출</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="align-middle fs-4 mb-2">
          <i class="bi bi-arrow-down-square-fill text-secondary"  v-if="this.createWFlag == 'Y'"></i>
        </div>

        <div style="width: auto; height: auto;">
          <Modal_ExpReceipt v-if="showModal" :showModal="showModal" :modalContent="arr_expenseInfo" @close="closeModal"/>
          <Modal_DepositSearch v-if="showDepositSearchModal" :showModal="showDepositSearchModal" :modalContent="depositSearchContext" @close="closeDepositSearchModal" @applied="handleDepositApplied"/>
        </div>

        <hr class="mt-4 mb-4">

        <div class="text-success text-start fs-6 d-flex justify-content-between align-items-center flex-wrap" id="withdrawal">
          <div>
            <b>[ &nbsp; 지출내역 &nbsp; ]</b>&nbsp;&nbsp;&nbsp; <i style="font-size: small; color:gray">총액: <b>{{ this.getCurrencyFormat( this.expTotal) }}</b> 원</i>&nbsp;&nbsp;&nbsp;

            <a href="#sales" class="btn btn-outline-info btn-sm" style="font-size: 0.7rem;"> → 판매내역으로</a>&nbsp;&nbsp;
            <a href="#deposit" class="btn btn-outline-primary btn-sm" style="font-size: 0.7rem;"> → 입금내역으로</a>
          </div>

          <button class="btn btn-success btn-sm" @click="makeExpenditure('')">선택항목 지출품의</button>
        </div>

        <table class="table table-bordered table-striped fs-6">
          <thead class="small">
            <tr>
              <th style="width:3%;">
                <input class="form-check-input" type="checkbox" v-model="allSelected" @change="allChoice()" />
              </th>
              <th style="width:7%;"><span class="text-danger">*</span>항목</th>
              <th style="width:10%;"><span class="text-danger">*</span>항목명</th>
              <th style="width:8%;"><span class="text-danger">*</span>거래처</th>
              <th style="width:5%;"><span class="text-danger">*</span>지출일자</th>
              <th style="width:6%;"><span class="text-danger">*</span>지출액</th>
              <th style="width:5%;"><span class="text-danger">*</span>통화/환율</th>
              <th style="width:6%;"><span class="text-danger">*</span>지출수단/수수율</th>
              <th style="width:7%;">환산액</th>
              <th style="width:3%;"><span class="text-danger">*</span>수량</th>
              <th style="width:8%;">합계액</th>
              <th style="width:10%;">계좌정보</th>
              <th style="width:10%;">비고사항</th>
              <th style="width:5%;">-</th>
            </tr>
          </thead>
          <tbody class="small">
            <tr :key="i" v-for="(w,i) in dWithdrawalInfo">
              <td>
                {{ i+1 }}
                <p>
                  <input type="checkbox" v-model="w.checkFlag"  ref="chb_Seq" class="align-baseline mt-3" :id=i name="checkedBox" :disabled="w.reqStat == 'lv1' || w.reqStat == 'lv5' || w.reqStat == 'lv9' || w.reqStat == 'rj5' || w.reqStat == 'rj9'">
                </p>
              </td>
              <td>
                {{ w.expCodeName }}
                <P style="padding-top:0.5rem;">
                  <button class="btn btn-success btn-sm" :disabled="w.reqStat == 'lv1' || w.reqStat == 'lv5' || w.reqStat == 'lv9' || w.reqStat == 'rj5' || w.reqStat == 'rj9'" @click="makeExpenditure(i)">지출품의</button>
                </P>
              </td>
              <td>
                <p class="text-secondary" style="font-size:small">{{ w.exName }}</p>
                <p class="text-secondary" style="font-size:small">{{ w.expCode }}</p>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="w.dPartnerCd" style="font-size: smaller;" @change="getBankInfo(w.dPartnerCd, i)">
                  <option v-show="p.pCode != 'ZETD'" :value="p.pCode" :key="i" v-for="(p,i) in this.partnerInfo">{{ p.pName }}</option>
                </select>
                <p class="mt-1"  v-if="w.dPartnerCd === 'ZETW'">
                  <input type="text" v-model="w.etcPaName" maxlength="15" ref="w_exPartnerName" class="resize-input" placeholder="명칭">
                  <input type="text" v-model="w.etcPaTel" maxlength="15" ref="w_exPartnerTel" class="resize-input" placeholder="연락처(숫자만)">
                </p>
              </td>
              <td>
                <input type="date" class="form-control form-control-sm" ref="w_expDate" v-model="w.dDate" style="font-size:smaller">
              </td>
              <td>
                <input type="text" v-model="w.dPrice" maxlength="10" ref="w_expAmt" placeholder="숫자만" class="resize-input">
                <p class="mt-2 text-secondary text-sm-end">
                  {{ this.getCurrencyFormat(w.dPrice) }}
                </p>
              </td>
              <td>
                <select class="form-select form-select-sm" v-model="w.dCurCd" style="font-size: smaller;" ref="w_expCurCd" @change="getExRate1(w.dCurCd, i, 'W')">
                  <option :value="c.fCodeNo" :key="k" v-for="(c,k) in this.finCode_currB">{{ c.fName }}</option>
                </select>
                <p class="mt-1">
                  <input type="text" v-model="w.dExRate" maxlength="10" ref="w_expExRate" placeholder="소숫점2자리까지" class="resize-input">
                </p>
              </td>

              <td>
                <select class="form-select form-select-sm" v-model="w.dPayMethod" style="font-size: smaller;" ref="w_expPayMethod" @change="changePaymethod('R',w.dPayMethod,i)">
                  <option :value="r.baseCode" :key="k" v-for="(r,k) in this.payMethodListB">{{ r.codeNameKor }}</option>
                </select>
                <p class="mt-1 mb-1">
                  <select class="form-select form-select-sm" v-model="w.dPayCode" style="font-size: smaller;" ref="w_expPayCode" @change="getFeeRate1(w.dPayCode, i, 'W')">
                    <option :value="w.dPayCode" disabled v-if="this.payCodeListB[i] == undefined">{{ w.finName }}</option>
                    <option :value="p.fCodeNo" :key="i" v-for="(p,i) in this.payCodeListB[i]">{{ p.fName }}</option>                    
                  </select>
                </p>
                <p class="mt-0 mb-0">
                  <input type="text" v-model="w.dFeeRate" maxlength="10" ref="w_expFeeRate" placeholder="소숫점2자리까지" class="resize-input">
                </p>
              </td>              
              
              <td>
                <p class="mt-1 text-secondary text-end">
                  {{ this.getCurrencyFormat(Math.trunc((w.dPrice * 1) * (w.dExRate * 1))) }}원
                  <br>
                  <span style="font-size: smaller; color:gray">(수수율 불포함)</span>
                </p>
              </td>
              <td>
                <input type="text" v-model="w.expQty" maxlength="10" ref="reg_expQty" class="resize-input">
              </td>
              <td>
                <b class="text-success">{{ this.getCurrencyFormat(Math.trunc((w.dPrice * 1) * (w.dExRate * 1) * (w.expQty * 1))) }}</b> 원
              </td>

              <td>
                <select class="form-select form-select-sm" v-model="w.bankCode" style="font-size: smaller;" ref="w_bankCode">
                  <option :value="c.fCodeNo" :key="i" v-for="(c,i) in this.bankInfo">{{ c.fName }}</option>
                </select>
                <p class="mt-1 mb-1">
                  <input type="text" v-model="w.bankAccount" maxlength="30" ref="w_bAccount" placeholder="계좌번호" class="resize-input">
                </p>
                <p class="mt-0 mb-0">
                  <input type="text" v-model="w.accHolder" maxlength="50" ref="w_accHolder" placeholder="예금주" class="resize-input" style="background-color: blanchedalmond;">
                </p>
              </td>

              <td>
                <textarea class="form-control resize-input" placeholder="300자 이내" ref="reg_dDetailRemarks" v-model="w.dDetailRemarks" maxlength="300" style="height: 80px;"></textarea>
              </td>
              
              <td v-if="this.user.handlerGrade <= 9">
                <div v-if="w.reqStat === 'lv0' || w.reqStat == null || w.reqStat == ''">
                  <button type="button" class="btn btn-outline-success btn-sm m-1" @click="changeDeposit(w.dealCode, w.dSubNo, i, 'W')" >
                    변경
                  </button>
                  <button type="button" class="btn btn-outline-danger btn-sm m-1" @click="excludeDeposit(w.dealCode, w.dSubNo, i , 'W', w.expCode)">
                    삭제
                  </button> 
                </div>
                <div v-else class="text-danger">
                  <div v-if="w.reqStat === 'lv9'">
                    품의완료
                  </div>
                  <div v-else-if="w.reqStat === 'rj5' || w.reqStat === 'rj9'">
                    품의반려
                  </div>
                  <div v-else>
                    품의중
                  </div>
                  <p @click="goToReqReqView(w.reqCode);" style="cursor:pointer; color:blue;">{{ w.reqCode }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </main>
  </div>
</template>

<script>
import Modal_ExpReceipt from "./Modal_ExpReceipt"
import * as XLSX from 'xlsx'
import LoadingSpinner from '../components/LoadingSpinner.vue';     // 로딩스피너 컴포넌트
import Modal_DepositSearch from "./Modal_DepositSearch"            // 간편입금처리를 위한 모달

export default {
  components: {
    Modal_ExpReceipt,
    Modal_DepositSearch,
    LoadingSpinner
  },
  data() {
    return {
      isLoading: false,                 // 로딩 스피너 표시 여부(엑셀 일괄등록 처리 중 화면잠금용)
      isUploading: false,               // 엑셀 일괄등록 진행중 여부(파일선택~등록완료 전 구간, 이중실행 차단용)

      cusName:    "",
      cusCnt:      0,
      dSalePrice:  0,
      dSaleFee:    0,
      dSaleMemo:  "",
      dSalePrice_tot: 0,

      sa_cusName:    "",
      sa_cusCnt:      0,
      sa_dSalePrice:  0,
      sa_dSaleFee:    0,
      sa_dSaleMemo:  "",
      sa_dSalePrice_tot: 0,
      sa_channelCode: "",
      sa_channelResCode: "",

      sa_channelKeyword: "",            // 판매수단 검색키워드(입력용)
      sa_channelSearchResult: [],       // 판매수단 검색결과(자동완성)
      allPartnerCodes: [],              // 전체 거래처/수단 코드(활성여부 무관) - 자동코드생성 시 중복체크용

      dealInfoDetail: [],
      dDepositInfo: [],
      dWithdrawalInfo: [],
      changePermission: "",
      finCodeList: [],
      finCode_curr: [],
      payMethodList: [],
      payCodeList: [],
      chargePList: [],
      partnerInfo: [],
      saleChInfo:  [],

      finCodeListB: [],
      finCode_currB: [],
      payMethodListB: [],
      payCodeListB: [],

      dptCtList: [],
      tripNtList: [],
      tripArList: [],
      tripArListforSearch: [],
      tripArList_tmp: [],

      reqStatusInfo: [],

      createDFlag: "N",
      createWFlag: "N",

      dDealDetail: "",
      dPrice: 0,
      dCurCd: "",
      dExRate: 1.00,
      dPayMethod:"",
      dPayCode: "",
      dFeeRate: 0.00,
      dDate: "",
      dDepositor: "",
      dPartnerCd: "",
      dDetailRemarks: "",

      dBalance: 0,
      sumOfConvMoney: 0,

      searchDuration: "G",
      searchStart: "",
      searchEnd: "",
      dealName: "",
      chargePerson: "",

      searchNtCd: "",
      searchArCd: "",
      resName: "",
      searchCon: "",

      expCatList: [],
      expInfo: [],
      expInfo1: [],
      expenditureInfo: [],

      expCatCode: "",
      expCode: "",
      expName: "",
      expPartnerCd: "",
      exPartnerName: "",
      exPartnerTel: "",
      expDate: "",
      expAmt: 0,
      expCurCd: "",
      expExRate: 1.00,
      expConvMoney: 0,
      expQty: 1,
      expHandler: "",
      expRemarks: "",
      expPayMethod: "",
      expPayCode: "",
      expFeeRate: 0.00,

      expTotal: 0,

      bankInfo: [],
      bankCode: "",
      bAccount: "",
      accHolder: "",
      
      partnerInfoByCode: [],

      showModal: false,
      modalContent: "",

      createSFlag: "N",

      salesHistoryInfo: [],

      newDealFlag: "N",
      highlightedSubNo: null,

      expPartnerKeyword: "",            // 지출 거래처 검색키워드(입력용)
      expPartnerSearchResult: [],       // 지출 거래처 검색결과(자동완성)

      showDepositSearchModal: false,     // 입금내역 검색 모달 표시여부
      depositSearchContext: null,        // 모달에 넘길 프리필 컨텍스트(고객명/판매수단)      
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.dealCode = this.$route.query.dCode;

    this.getDealInfoDetail(this.dealCode)
    this.getCategoryList();
    this.getBasicCode();

    this.getCategoryList_exp()
    this.getExpenditureInfo()

    this.getPartnerList();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },

    // 판매내역 등록 가능 여부 - 신정산 대상이면서, 취소/정산중/정산완료 상태가 아닐 때만 허용
    canRegisterSale() {
      return this.newDealFlag === 'Y' && !['EC', 'SG', 'SE'].includes(this.dealInfoDetail.reqStatus)
    },

    // 판매액(①, 수수료 차감 전) 누적 - 판매현황 "①판매액" 표시용
    salesPriceTotal() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return 0;
      return this.salesHistoryInfo.reduce((sum, sh) => sum + (sh.sa_dSalePrice * 1 || 0), 0);
    },

    // 판매내역 총액(③ 총판매가) 누적
    salesTotalAmt() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return 0;
      return this.salesHistoryInfo.reduce((sum, sh) => {
        return sum + ((sh.sa_dSalePrice * 1 || 0) - (sh.sa_dSaleFee * 1 || 0));
      }, 0);
    },
    salesUnpaidAmt() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return 0;
      return this.salesHistoryInfo.reduce((sum, sh) => {
        let dSalePriceTot = (sh.sa_dSalePrice * 1 || 0) - (sh.sa_dSaleFee * 1 || 0)
        let diff = (sh.sa_payAmt * 1 || 0) - dSalePriceTot
        return sum + (diff < 0 ? diff : 0);
      }, 0);
    },
    salesOverpaidAmt() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return 0;
      return this.salesHistoryInfo.reduce((sum, sh) => {
        let dSalePriceTot = (sh.sa_dSalePrice * 1 || 0) - (sh.sa_dSaleFee * 1 || 0)
        let diff = (sh.sa_payAmt * 1 || 0) - dSalePriceTot
        return sum + (diff > 0 ? diff : 0);
      }, 0);
    },

    // 판매수수료(②) 누적
    salesFeeTotal() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return 0;
      return this.salesHistoryInfo.reduce((sum, sh) => sum + (sh.sa_dSaleFee * 1 || 0), 0);
    },

    netUnpaidOverpaidLabel() {
      if (this.netUnpaidOverpaidAmt === 0) return '';
      return this.netUnpaidOverpaidAmt > 0 ? '(미수)' : '(과입)';
    },

    // ③-④ (판매현황 2번째 테이블용) 미수/과입: 정산액(③) - 입금액(④)
    netUnpaidOverpaidAmt() {
      return (this.salesTotalAmt * 1 || 0) - (this.sumOfConvMoney * 1 || 0);
    },

    // ⑥알선수수료(세전) = 입금액(④, 실제 들어온 돈) - 지출액(⑤, 통화별 실환율로 이미 환산된 expTotal)
    preVatProfitAmt() {
      return (this.sumOfConvMoney * 1 || 0) - (this.expTotal * 1 || 0);
    },

    // 부가가치세 (잠정수치 — 정산마감 전까지 계속 변동)
    vatAmt() {
      let base = Math.max(this.preVatProfitAmt, 0);
      return Math.floor((base / 1.1) * 0.1);
    },

    // ⑦공급가액 = 알선수수료(⑥, 세전) - 부가세(⑧)  ※변수명은 legacy(alseon수수료)지만 현재 표시는 "공급가액"
    brokerageAmt() {
      return this.preVatProfitAmt - this.vatAmt;
    },

    profitPerPax() {
      let paxCnt = this.dealInfoDetail.paxCnt * 1 || 0;
      if (paxCnt === 0) return 0;
      return Math.round(this.brokerageAmt / paxCnt);
    },

    // 행사수익률 = 공급가액/정산액(③) * 100
    profitRate() {
      let sales = this.salesTotalAmt * 1 || 0;
      if (sales === 0) return 0;
      return (this.brokerageAmt / sales) * 100;
    },

    // 정렬된 배열기준으로 번호표시
    saleSubNoDisplayMap() {
      let map = {}
      this.sortedSalesHistoryInfo.forEach((sh, idx) => {
        map[sh.sa_dSubNo] = idx + 1
      })
      return map
    },
    // 입금코드(exDepositNo)별 뱃지/배경 색상 매핑 (8색 순환, 라벨은 순환없이 계속 증가)
    depositCodeMeta() {
      const palette = [
        { badge: '#e74c3c', bg: '#fdecea' },
        { badge: '#2980b9', bg: '#eaf4fc' },
        { badge: '#27ae60', bg: '#eafaf1' },
        { badge: '#e67e22', bg: '#fdf2e3' },
        { badge: '#8e44ad', bg: '#f5eef8' },
        { badge: '#16a085', bg: '#e8f8f5' },
        { badge: '#c0392b', bg: '#fbeee9' },
        { badge: '#2c3e50', bg: '#eaeded' },
      ]
      let map = {}
      let idx = 0

      this.dDepositInfo.forEach(d => {
        if (!map[d.exDepositNo]) {
          map[d.exDepositNo] = {
            label: idx + 1,
            badge: palette[idx % palette.length].badge,
            bg: palette[idx % palette.length].bg
          }
          idx++
        }
      })
      return map
    },

    // 판매수단명 기준 정렬(가나다순), 같은 수단 내에서는 등록순(sa_dSubNo) 유지
    // 원본 salesHistoryInfo는 손대지 않고 표시용 배열만 별도로 만듦(입력값 편집은 객체 참조 공유라 그대로 반영됨)
    sortedSalesHistoryInfo() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return [];
      return [...this.salesHistoryInfo].sort((a, b) => {
        let chA = a.pName || a.sa_dSaleChCode || ''
        let chB = b.pName || b.sa_dSaleChCode || ''
        let chCompare = chA.localeCompare(chB, 'ko')
        if (chCompare !== 0) return chCompare
        return (a.sa_dSubNo * 1 || 0) - (b.sa_dSubNo * 1 || 0)
      });
    },

    // 판매수단별 총판매가(③=①-②) 합산 - 총액 옆 호버레이어용, 합계 큰 순으로 정렬
    salesByChannel() {
      if (!this.salesHistoryInfo || this.salesHistoryInfo.length === 0) return [];
      let grouped = {}
      this.salesHistoryInfo.forEach(sh => {
        let code = sh.sa_dSaleChCode || 'NOCH'
        let name = sh.pName || code
        if (!grouped[code]) grouped[code] = { channelCode: code, channelName: name, totalAmt: 0, cnt: 0 }
        grouped[code].totalAmt += (sh.sa_dSalePrice * 1 || 0) - (sh.sa_dSaleFee * 1 || 0)
        grouped[code].cnt += 1
      })
      return Object.values(grouped).sort((a, b) => b.totalAmt - a.totalAmt)
    },
  },
  mounted() {
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    this.dealChargeId = this.user.handlerId;
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    // API 응답 에러 판정
    // - req.db()는 쿼리 에러 시 {error} 객체를 반환
    // - $api는 통신오류/타임아웃 시 throw하지 않고 undefined를 반환
    // - 구형 응답은 affectedRows < 0 으로 에러를 표시
    isApiError(res){
      return !res || !!res.error || (typeof res.affectedRows === 'number' && res.affectedRows < 0)
    },

    // 엑셀 숫자 파싱 - 천단위 콤마, 통화기호, 공백 제거 후 숫자변환(실패 시 NaN)
    toNum(v){
      if(v === undefined || v === null) return NaN
      if(typeof v === 'number') return v
      let s = v.toString().replace(/[,\s₩원]/g, '')
      return s === '' ? NaN : Number(s)
    },

    getSaleSubInfo(subNo) {
      let found = this.salesHistoryInfo.find(sh => sh.sa_dSubNo === subNo)
      return found || {}
    },

    getPayMethodName(code) {
      let found = this.payMethodListB.find(p => p.baseCode === code)
      return found ? found.codeNameKor : code
    },
    
    scrollToSaleRow(subNo) {
      if(!subNo) return

      this.highlightedSubNo = subNo

      let el = document.getElementById('sale-row-' + subNo)
      if(el)
      {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      setTimeout(() => {
        if(this.highlightedSubNo === subNo) this.highlightedSubNo = null
      }, 2000)
    },

    // 판매건 컨텍스트(고객명/판매수단/dealCode/subNo 등)로 입금내역 검색모달 오픈
    openDepositSearch(sh){
      this.depositSearchContext = {
        custName: sh.sa_cusName,
        dealCode: this.dealCode,
        subNo: sh.sa_dSubNo,
        salePrice: sh.sa_dSalePrice,
        saleFee: sh.sa_dSaleFee,
        payAmt: sh.sa_payAmt,
        saleMemo: sh.sa_dSaleMemo
      }
      this.showDepositSearchModal = true
    },
    closeDepositSearchModal(){
      this.showDepositSearchModal = false
    },
    // 모달에서 입금처리 성공 시, 판매내역/입금현황을 최신화 (모달은 닫지 않고 유지)
    async handleDepositApplied(){
      await this.getDealInfoDetail(this.dealCode)
    },

    // 입금내역 테이블에서 특정 입금건(d, tb_dealhistory_pay_s row) 하나만 취소
    // Modal_DepositSearch.vue의 CX 로직과 동일하게, payCxlId로 마킹하는 게 아니라
    // proc_createExdepositSplit(DS/CX)로 상쇄레코드를 만들어 순액을 0으로 되돌리는 방식
    async cancelDepositPay(d){
      if(!d.sa_dSubNo)
      {
        this.$swal.fire("", "판매건과 연결되지 않은 입금내역은 이 화면에서 취소할 수 없습니다.", "warning")
        return
      }

      //이 입금건이 연결된 판매건의 현재 누적입금액(sa_payAmt) 조회 - 취소 후 남을 목표누적액 계산용
      let sh = this.salesHistoryInfo.find(s => s.sa_dSubNo === d.sa_dSubNo)
      if(!sh)
      {
        this.$swal.fire("", "연결된 판매내역을 찾을 수 없습니다.<br>새로고침 후 다시 시도해주세요.", "error")
        return
      }

      let confirm = await this.$swal.fire({
        html: "이 입금건으로 처리된 " + this.getCurrencyFormat(d.payAmt) + "원을 취소하시겠습니까?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "확인",
        cancelButtonText: "취소"
      })
      if(!confirm.isConfirmed) return

      //원본 입금건(exDepositNo) 정보 조회 - finCd(은행코드) 확보용
      //exDepoCode 정확일치 시 날짜조건과 배타적으로 처리된다고 알려져 있으나, 혹시 날짜조건이 완전히
      //스킵되지 않는 경우를 대비해 빈 문자열 대신 충분히 넓은 날짜범위를 함께 넘겨 안전하게 처리
      let today = new Date()
      let dSearchEnd = today.toISOString().slice(0, 10)
      let dSearchStart = "2000-01-01"

      let depositInfo = await this.$api("/api/proc_searchDepositHistory", {param: [
        "all", dSearchStart, dSearchEnd, "", 0, 999999999, "", "", "", d.exDepositNo
      ]})

      if(!depositInfo || !depositInfo[1] || depositInfo[1].length === 0)
      {
        this.$swal.fire("", "원본 입금건 정보를 찾을 수 없습니다.<br>이미 처리되었거나 삭제된 입금건일 수 있습니다.", "error")
        return
      }
      let di = depositInfo[1][0]

      //취소 후 이 판매건에 남을 누적입금액 = 현재누적액 - 이번에 취소할 이 건의 금액
      let targetPayAmt = (sh.sa_payAmt * 1 || 0) - (d.payAmt * 1 || 0)

      let param = "DS"
      let simpleName = ""
      let dFlag = "D"
      let dCurCd = "KRW"
      let dExRate = 1
      let dPayMethod = d.payMethod
      let finCd = di.finCd
      let dPayCode = finCd
      let dFeeRate = 0
      let dUseFlag = "Y"
      let splitFlag = "Y"
      let exUseFlag = "Y"

      let res = await this.$api("/api/proc_createExdepositSplit", {param: [
        param, simpleName,
        d.exDepositNo, this.dealCode, 0, this.user.handlerId, exUseFlag, d.payRemarks, finCd, this.user.handlerId,
        dFlag, dCurCd, dExRate, 0, dPayMethod, dPayCode, dFeeRate, d.payRemarks, d.payDepositor, this.getDateFormat(di.depositDate), dUseFlag,
        splitFlag, sh.sa_cusName, d.sa_dSubNo, targetPayAmt, "CX"
      ]})

      if(Object.keys(res)[0] === "error")
      {
        this.$swal.fire("", "입금취소 실패(" + res.error.sqlMessage + ")", "error")
        return
      }

      this.$swal.fire("", "입금취소가 완료되었습니다.", "success")
      await this.getDealInfoDetail(this.dealCode)
    },

    // 지출 거래처 키워드검색(자동완성)
    searchExpPartner(){
      this.expPartnerCd = ""   //재검색 시작 시, 확정된 거래처코드는 초기화(새로 선택하기 전까진 미확정)

      let keyword = this.expPartnerKeyword.trim()
      if(!keyword)
      {
        this.expPartnerSearchResult = []
        return
      }

      let lowerKeyword = keyword.toLowerCase()
      this.expPartnerSearchResult = this.partnerInfo.filter(p => {
        return p.pCode !== 'ZETD' && (p.pName.toLowerCase().includes(lowerKeyword) || p.pCode.toLowerCase().includes(lowerKeyword))
      })
    },

    // 자동완성 목록에서 지출 거래처 선택
    selectExpPartner(p){
      this.expPartnerCd = p.pCode
      this.expPartnerKeyword = `[${p.pCode}] ${p.pName}`
      this.expPartnerSearchResult = []
      this.getBankInfo(p.pCode, 'C')   //선택 시 계좌정보 자동채움 (기존 select @change와 동일 동작)
    },

    // 엔터 또는 포커스아웃 시, 입력값이 확정된 거래처인지 확인 - 미등록 거래처면 신규등록 여부 확인
    async confirmExpPartnerInput(){
      let keyword = this.expPartnerKeyword.trim()

      if(!keyword)
      {
        this.expPartnerCd = ""
        this.expPartnerSearchResult = []
        return
      }

      //이미 자동완성으로 확정된 상태면 그대로 진행
      if(this.expPartnerCd) return

      //입력값과 거래처명이 정확히 일치하면 자동으로 확정 처리
      let matched = this.partnerInfo.find(p => p.pCode !== 'ZETD' && p.pName.toLowerCase() === keyword.toLowerCase())
      if(matched)
      {
        this.selectExpPartner(matched)
        return
      }

      //일치하는 거래처가 없는 경우 - 신규등록 여부 확인
      let confirm = await this.$swal.fire({
        html: `"${keyword}"(은)는 등록되지 않은 거래처입니다.<br>거래처로 신규등록하시겠습니까?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "예",
        cancelButtonText: "아니오"
      })

      if(confirm.isConfirmed)
      {
        await this.registExpPartner(keyword)
      }
      else
      {
        this.expPartnerKeyword = ""
        this.expPartnerSearchResult = []
      }
    },

    // 지출 거래처 신규등록 - registSaleChannel과 동일 구조(ins_partnerInfo 재사용), partFlag/sChFlag만 반대로 설정
    async registExpPartner(keyword){
      const { value: pName } = await this.$swal.fire({
        html: '거래처 정식명칭 입력(필수)',
        input: 'text',
        inputValue: keyword,
        inputPlaceholder: "최대40자",
        inputValidator: (value) => {
          if(!value || !value.trim()) return "거래처명을 입력하세요."
          if(value.trim().length > 40) return "최대 40자까지 입력 가능합니다."
        }
      })

      if(!pName)
      {
        this.expPartnerKeyword = ""
        this.expPartnerSearchResult = []
        return
      }

      let trimmedName = pName.trim()

      let insId = this.user.handlerId
      let pUseFlag = "Y"
      let sChFlag = "N"     //판매수단 아님
      let partFlag = "Y"    //거래처로 등록

      let maxAttempts = 5
      let attempt = 0
      let ins_partnerInfo = null
      let usedCode = null

      while(attempt < maxAttempts)
      {
        usedCode = this.generateChannelCode(trimmedName)   //판매수단과 동일한 3자 자동코드생성 로직 재사용

        if(!usedCode)
        {
          this.$swal.fire('', '거래처코드 자동생성에 실패했습니다.<br>잠시 후 다시 시도해주세요.', 'error')
          this.expPartnerKeyword = ""
          this.expPartnerSearchResult = []
          return
        }

        ins_partnerInfo = await this.$api("/api/ins_partnerInfo", {param: [
          usedCode, "", trimmedName, "", "", "", "", pUseFlag, insId, "", "", "", "", "", "", sChFlag, partFlag
        ]})

        let isDupError = ins_partnerInfo.affectedRows < 0 &&
          ins_partnerInfo.error && ins_partnerInfo.error.sqlMessage &&
          ins_partnerInfo.error.sqlMessage.includes('Duplicate')

        if(isDupError)
        {
          this.allPartnerCodes.push(usedCode)
          attempt++
          continue
        }

        break
      }

      if(ins_partnerInfo.affectedRows < 0)
      {
        this.$swal.fire('','등록실패('+ ins_partnerInfo.error.sqlMessage +')', 'error')
        this.expPartnerKeyword = ""
        this.expPartnerSearchResult = []
        return
      }

      this.$swal.fire('', `거래처가 등록되었습니다. (코드: ${usedCode})`, 'success')

      //거래처리스트 갱신 후, 방금 등록한 거래처를 자동선택
      await this.getPartnerList()

      let newPartner = this.partnerInfo.find(p => p.pCode === usedCode)
      if(newPartner)
      {
        this.selectExpPartner(newPartner)
      }
    },

    // 판매수단 키워드검색(자동완성)
    searchSaleChannel(){
      this.sa_channelCode = ""   //재검색 시작 시, 확정된 수단코드는 초기화(새로 선택하기 전까진 미확정)

      let keyword = this.sa_channelKeyword.trim()
      if(!keyword)
      {
        this.sa_channelSearchResult = []
        return
      }

      let lowerKeyword = keyword.toLowerCase()
      this.sa_channelSearchResult = this.saleChInfo.filter(sch => {
        return sch.pName.toLowerCase().includes(lowerKeyword) || sch.pCode.toLowerCase().includes(lowerKeyword)
      })
    },

    // selectSaleChannel()
    selectSaleChannel(sch){
      this.sa_channelCode = sch.pCode
      this.sa_channelKeyword = `[${sch.pCode}] ${sch.pName}`
      this.sa_channelSearchResult = []
      if(sch.pCode.toUpperCase() === 'TAX') this.sa_cusCnt = 0
    },

    // 엔터 또는 포커스아웃 시, 입력값이 확정된 판매수단인지 확인 - 미등록 수단이면 신규등록 여부 확인
    async confirmChannelInput(){
      let keyword = this.sa_channelKeyword.trim()

      if(!keyword)
      {
        this.sa_channelCode = ""
        this.sa_channelSearchResult = []
        return
      }

      //이미 자동완성으로 확정된 상태면 그대로 진행
      if(this.sa_channelCode) return

      //입력값과 수단명이 정확히 일치하면 자동으로 확정 처리
      let matched = this.saleChInfo.find(sch => sch.pName.toLowerCase() === keyword.toLowerCase())
      if(matched)
      {
        this.selectSaleChannel(matched)
        return
      }

      //일치하는 판매수단이 없는 경우 - 신규등록 여부 확인
      let confirm = await this.$swal.fire({
        html: `"${keyword}"(은)는 등록되지 않은 판매수단입니다.<br>자주 사용하는 판매수단로 등록하시겠습니까?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "예",
        cancelButtonText: "아니오"
      })

      if(confirm.isConfirmed)
      {
        await this.registSaleChannel(keyword)
      }
      else
      {
        this.sa_channelKeyword = ""
        this.sa_channelSearchResult = []
      }
    },

    // 판매수단 pCode 자동생성(3자, 중복방지) - 정식명칭 기준 영문/숫자 추출 후 순차적으로 대체안 탐색
    generateChannelCode(baseText){
      let clean = (baseText || "").toUpperCase().replace(/[^A-Z0-9]/g, "")
      let base = clean.substring(0, 3).padEnd(3, "X")   //3자 미만이면 X로 채움

      let existingCodes = this.allPartnerCodes || []

      //1차: 정식명칭 기반 3자 그대로 시도
      if(!existingCodes.includes(base)) return base

      //2차: 마지막 1자리를 숫자(0~9)로 치환하며 재시도
      for(let i = 0; i < 10; i++)
      {
        let candidate = base.substring(0, 2) + i
        if(!existingCodes.includes(candidate)) return candidate
      }

      //3차: 뒤 2자리를 숫자 조합으로 치환하며 재시도
      for(let i = 0; i < 10; i++)
      {
        for(let j = 0; j < 10; j++)
        {
          let candidate = base.substring(0, 1) + i + j
          if(!existingCodes.includes(candidate)) return candidate
        }
      }

      //4차: 그래도 겹치면 완전 랜덤 3자(영문대문자)로 탐색
      let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
      for(let attempt = 0; attempt < 50; attempt++)
      {
        let candidate = Array.from({length:3}, () => chars[Math.floor(Math.random()*chars.length)]).join("")
        if(!existingCodes.includes(candidate)) return candidate
      }

      return null   //극히 예외적인 경우(사실상 발생 불가)
    },

    // 판매수단 신규등록 - partnerList.vue의 거래처등록(ins_partnerInfo)과 동일 API를 판매수단 전용으로 간소화 재사용
    async registSaleChannel(keyword){
      //정식 수단명 입력받기(검색어를 기본값으로 제안)
      const { value: pName } = await this.$swal.fire({
        html: '판매수단 정식명칭 입력(필수)',
        input: 'text',
        inputValue: keyword,
        inputPlaceholder: "최대40자",
        inputValidator: (value) => {
          if(!value || !value.trim()) return "수단명을 입력하세요."
          if(value.trim().length > 40) return "최대 40자까지 입력 가능합니다."
        }
      })

      //명칭입력 취소 시 등록중단
      if(!pName)
      {
        this.sa_channelKeyword = ""
        this.sa_channelSearchResult = []
        return
      }

      let trimmedName = pName.trim()

      let insId = this.user.handlerId
      let pUseFlag = "Y"
      let sChFlag = "Y"     //판매수단로 등록
      let partFlag = "N"    //거래처(지출용)로는 등록하지 않음 - 판매수단 전용

      let maxAttempts = 5
      let attempt = 0
      let ins_partnerInfo = null
      let usedCode = null

      //코드충돌(동시등록 등 경합상황) 시 다른 코드로 재시도
      while(attempt < maxAttempts)
      {
        usedCode = this.generateChannelCode(trimmedName)

        if(!usedCode)
        {
          this.$swal.fire('', '판매수단코드 자동생성에 실패했습니다.<br>잠시 후 다시 시도해주세요.', 'error')
          this.sa_channelKeyword = ""
          this.sa_channelSearchResult = []
          return
        }

        ins_partnerInfo = await this.$api("/api/ins_partnerInfo", {param: [
          usedCode, "", trimmedName, "", "", "", "", pUseFlag, insId, "", "", "", "", "", "", sChFlag, partFlag
        ]})

        let isDupError = ins_partnerInfo.affectedRows < 0 &&
          ins_partnerInfo.error && ins_partnerInfo.error.sqlMessage &&
          ins_partnerInfo.error.sqlMessage.includes('Duplicate')

        if(isDupError)
        {
          this.allPartnerCodes.push(usedCode)   //방금 겹친 코드도 후보에서 제외되도록 반영 후 재시도
          attempt++
          continue
        }

        break   //성공 또는 중복이 아닌 다른 오류 -> 루프탈출
      }

      if(ins_partnerInfo.affectedRows < 0)
      {
        this.$swal.fire('','등록실패('+ ins_partnerInfo.error.sqlMessage +')', 'error')
        this.sa_channelKeyword = ""
        this.sa_channelSearchResult = []
        return
      }

      this.$swal.fire('', `판매수단이 등록되었습니다. (코드: ${usedCode})`, 'success')

      //판매수단리스트 갱신 후, 방금 등록한 수단을 자동선택
      await this.getPartnerList()

      let newChannel = this.saleChInfo.find(sch => sch.pCode === usedCode)
      if(newChannel)
      {
        this.selectSaleChannel(newChannel)
      }
    },

    nAlert(){
      this.$swal.fire('', '확정된 내역입니다.<br>확정취소 권한자에게 문의하세요.', 'info')
      return false;
    },
    
    allChoice() 
    {
      if(this.allSelected)
      {
        this.dWithdrawalInfo.forEach((i) => {
          if(i.reqStat != "lv1" && i.reqStat != "lv5" && i.reqStat != "lv9" && i.reqStat != "rj5" && i.reqStat != "rj9")
          {
            i.checkFlag = true;
          }
        })
      }
      else
      {
        this.dWithdrawalInfo.forEach((i) => {
          i.checkFlag = false;
        })
      }
    },

    goToReqReqView(rCode) {
      this.$router.push({path: '/expenseReportView', query: {rCode: rCode}});
    },

    makeExpenditure(val){
      let selectedIndex = []

      if(val === undefined || val === null || val === "")
      {
        this.dWithdrawalInfo.forEach((i) => {
          if(i.checkFlag)
          {
            selectedIndex.push(i)
          }
        })
      }
      else
      {
        selectedIndex.push(this.dWithdrawalInfo[val])
      }

      //console.log("selectedIndex:", selectedIndex)

      if(selectedIndex.length > 0)
      {
        this.$swal.fire({
          html: '선택된 지출내역별 증빙자료가 있습니까?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          icon: "question"
        }).then((result) => {
          if(result.isConfirmed)
          {
            this.showModal = true;
            this.arr_expenseInfo = selectedIndex;
          }
        })
      }
      else
      {
        this.$swal.fire("", "선택된 항목이 없습니다.", "warning")
        return false;
      }

    },

    closeModal(){
      this.showModal = false;
    },

    async getDealInfoDetail(dCode) {
      let dealInfoDetail = await this.$api("/api/dealInfoDetail", {param: [dCode]});

      if(dealInfoDetail.length > 0)
      {
        this.dealInfoDetail = dealInfoDetail[0]
        this.dealInfoDetail.evtStartDate = this.getDateFormat(this.dealInfoDetail.evtStartDate)
        this.dealInfoDetail.evtCloseDate = this.getDateFormat(this.dealInfoDetail.evtCloseDate)
        if(this.dealInfoDetail.reqStatus === 'SE' || this.dealInfoDetail.reqStatus === 'SG')
        {
          this.changePermission = 'N'
        }
        if(this.dealInfoDetail.newFlag != null && this.dealInfoDetail.newFlag === 'Y')
        {
          this.newDealFlag = "Y"
        }
      }
      //console.log("dealInfoDetail:",this.dealInfoDetail, "newDealFlag:>>", this.newDealFlag);

      //await 추가 - 호출부에서 await getDealInfoDetail() 한 뒤에는 판매/입금/지출 목록까지 최신상태임을 보장
      await this.getDepositInfo(this.dealCode)
    },

    async getCategoryList()
    {
      let reqStatusInfo = await this.$api("/api/reqStatusInfo", {param: ['SET', 'Y']});
      if(reqStatusInfo.length > 0)
      {
        this.reqStatusInfo = reqStatusInfo
      }

      let dptCtList = await this.$api("/api/searchBasecode", {param: ['ctCd']});
      if(dptCtList.length > 0)
      {
        this.dptCtList = dptCtList
      }

      let tripNtList = await this.$api("/api/searchBasecode", {param: ['ntCd']});
      if(tripNtList.length > 0)
      {
        this.tripNtList = tripNtList
      }

      let tripArList = await this.$api("/api/searchBasecode", {param: ['arCd']});
      if(tripArList.length > 0)
      {
        this.tripArList = tripArList
      }

      let chargePList = await this.$api("/api/handlerInfo", {})
      if(chargePList.length > 0)
      {
        this.chargePList = chargePList;
      }
    },
    changeNationList(param) {
      this.viewAreaList(param);
    },
    async viewAreaList(param1){
      let tripArList = await this.$api("/api/searchBasecode", {param: ['arCd']});

      if(tripArList.length > 0)
      {
        this.tripArList_tmp = tripArList
      }

      this.tripArList = this.tripArList_tmp.filter(e => {return e.categoryCode === param1});
    },

    async getCategoryList_exp() 
    {
      let expCatList = await this.$api("/api/reqStatusInfo2", {param: ['EXP', '%']});
      if(expCatList.length > 0)
      {
        this.expCatList = expCatList
      }
    },

    changeExpCatCode(expCatCode){
      let expInfo = []
      expInfo = this.expenditureInfo.filter(e => {return e.expCategory === expCatCode})
      
      if(expInfo.length > 0)
      {
        this.expInfo = expInfo
      }
      else
      {
        this.expInfo = ""
      }
    },

    async getExpenditureInfo(){
      let expenditureInfo = await this.$api("/api/expenditureInfo", {param: ["Y"]})

      if(expenditureInfo.length > 0)
      {
        this.expenditureInfo = expenditureInfo
      }
    },

    updateEvent(dealCode)
    {
      this.$swal.fire({
        title: '기본정보를 변경합니까?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let updDealInfoDetail = await this.$api("/api/updDealInfoDetail", {param: [
            this.dealInfoDetail.dealNameKor,this.dealInfoDetail.dealNameEng,this.dealInfoDetail.reqName,this.dealInfoDetail.reqTelNo,this.dealInfoDetail.reqEmail,this.dealInfoDetail.dptCtCode,this.dealInfoDetail.ntCd,this.dealInfoDetail.arCd,this.dealInfoDetail.evtStartDate,this.dealInfoDetail.evtCloseDate,this.dealInfoDetail.dealPrice_tot,this.dealInfoDetail.evRemarks,this.dealInfoDetail.reqStatus,this.user.handlerId,this.dealInfoDetail.dealChargeId,this.dealInfoDetail.paxCnt, dealCode
          ]});
          if(updDealInfoDetail.affectedRows >= 0)
          {
            let upd_dealHistory_m = await this.$api("/api/upd_dealHistory_m", {param:[
              this.dealInfoDetail.dealPrice_tot, this.user.handlerId, dealCode
            ]})
            if(upd_dealHistory_m.affectedRows > 0)
            {
              this.$swal.fire('', '변경완료', 'success')
              location.reload();
            }
          }
          else
          {
            this.$swal.fire('', '오류가 발생했습니다(코드:updDealInfoDetail)', 'warning')
            return false;
          }
        }
      })
    },

    cancelEvent(dCode)
    {
      this.$swal.fire({
        html: '행사를 취소합니까?',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let cxl_dealInfo = await this.$api("/api/cxl_dealInfo", {param: ['EC',this.user.handlerId, dCode]});
          if(cxl_dealInfo.affectedRows > 0)
          {
            this.$swal.fire('', '취소완료', 'success')
            location.reload();
          }
          else
          {
            this.$swal.fire('', '오류가 발생했습니다(코드:cxl_dealInfo)', 'warning')
            return false;
          }
        }
      })
    },

    cancelSE(dCode)
    {
      let reqStatus = "EE"
      this.$swal.fire({
        html: '정산완료에서 행사마감으로 상태를 변경합니까?',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let cxl_dealSE = await this.$api("/api/cxl_dealSE", {param: [reqStatus,this.user.handlerId, dCode]});
          if(cxl_dealSE.affectedRows > 0)
          {
            this.$swal.fire('', '정산완료취소', 'success')
            location.reload();
          }
          else
          {
            this.$swal.fire('', '오류가 발생했습니다(코드:cxl_dealSE)', 'warning')
            return false;
          }
        }
      })
    },

    // proc_cxlSplitInfo 방식으로 취소된 행인지 판별
    // - 이 방식은 원래 +행에 payUseFlag='N' / payCxlId만 마킹하고 상쇄(-)행을 만들지 않음
    // - CX 방식의 상쇄(-)행은 payCxlId가 있어도 payUseFlag='Y'이고 금액이 음수라 여기 해당하지 않음
    isMarkedCancelPay(d){
      if(d.payUseFlag !== undefined && d.payUseFlag !== null) return d.payUseFlag === 'N'
      return !!d.payCxlId && (d.payAmt * 1) > 0   //프로시저가 payUseFlag를 안 내려주는 경우 대비
    },

    // 입금 후 취소로 완전상쇄되는 +/- 쌍을 찾아 화면 표시대상에서 제외 - 순수 유효입금만 표시
    // - 0원 건은 무조건 제외
    // - 같은 판매건(sa_dSubNo) 내에서 절대값이 정확히 일치하는 +/- 쌍만 완전상쇄로 판단해 둘 다 제외
    //   (depositPay 잠금 로직으로 취소는 항상 원금과 정확히 일치하는 -N만 생기므로 부분취소 조각은 발생하지 않음)
    filterOffsettingPayPairs(list)
    {
      let filtered = list.filter(d => parseFloat(d.payAmt) !== 0)

      let grouped = {}
      filtered.forEach(d => {
        //같은 판매건 + 같은 입금건 안에서만 상쇄쌍을 찾음
        //(재입금 시 다른 입금건의 +행이 취소행과 잘못 짝지어져 숨겨지는 문제 방지)
        let key = (d.sa_dSubNo || 'NOSUB') + '|' + (d.exDepositNo || '')
        if(!grouped[key]) grouped[key] = []
        grouped[key].push(d)
      })

      let cancelSet = new Set()   //제외대상 원본 row 참조 저장(필드명에 의존하지 않기 위해 객체 자체를 key로 사용)

      Object.values(grouped).forEach(group => {
        let posMap = {}
        let negMap = {}

        group.forEach(d => {
          let amt = parseFloat(d.payAmt)
          let absAmt = Math.abs(amt)
          let target = (amt > 0) ? posMap : negMap
          if(!target[absAmt]) target[absAmt] = []
          target[absAmt].push(d)
        })

        Object.keys(posMap).forEach(absAmt => {
          let posList = posMap[absAmt]
          let negList = negMap[absAmt] || []
          let cancelCount = Math.min(posList.length, negList.length)

          for(let i = 0; i < cancelCount; i++)
          {
            cancelSet.add(posList[i])
            cancelSet.add(negList[i])
          }
        })
      })

      return filtered.filter(d => !cancelSet.has(d))
    },

    async showRegitDeposit(param)
    {
      let finCodeList = await this.$api("/api/finCodeList", {});
      if(finCodeList.length > 0)
      {
        this.finCodeList = finCodeList;
        this.finCode_curr = this.finCodeList.filter((item) => {
          return item.fCategory === 'Currency';
        })
      }
      let payMethodList = await this.$api("/api/baseCategory", {param: ['fnCd']});
      if(payMethodList.length > 0)
      {
        this.payMethodList = payMethodList
      }
      this.getPartnerList();

      if(param === "D")
      {
        this.createDFlag = (this.createDFlag === "Y") ? "N" : "Y";
      }
      else if(param === "W")
      {
        this.createWFlag = (this.createWFlag === "Y") ? "N" : "Y";
      }
      else if(param === "S")
      {
        this.createSFlag = (this.createSFlag === "Y") ? "N" : "Y";
      }
    },

    async getBasicCode()
    {
      let finCodeListB = await this.$api("/api/finCodeList", {});
      if(finCodeListB.length > 0)
      {
        this.finCodeListB = finCodeListB;
        this.finCode_currB = this.finCodeListB.filter((item) => {
          return item.fCategory === 'Currency';
        })

        this.bankInfo = this.finCodeListB.filter((item) => {
          return (item.fCategory === 'Inst' && item.fCategory2 === 'Bank') ;
        })
      }
      let payMethodListB = await this.$api("/api/baseCategory", {param: ['fnCd']});
      if(payMethodListB.length > 0)
      {
        this.payMethodListB = payMethodListB
      }

      let expInfo1 = await this.$api("/api/expenditureInfo", {param: ["Y"]})

      if(expInfo1.length > 0)
      {
        this.expInfo1 = expInfo1
      }

      this.getPartnerList();
    },

    async getPartnerList() {
      let partnerInfo_tmp = await this.$api("/api/partnerInfo", {});

      //판매수단코드 자동생성 시 중복체크용 - 활성/비활성, 거래처/수단 구분 없이 전체 코드 보관
      this.allPartnerCodes = partnerInfo_tmp.map(item => item.pCode)

      let partnerInfo = partnerInfo_tmp.filter((item) => {
        return (item.partFlag === 'Y' && item.pUseFlag === 'Y')
      })

      let saleChInfo = partnerInfo_tmp.filter((item) => {
        return (item.saleChFlag === 'Y' && item.pUseFlag === 'Y')
      })      

      if(partnerInfo.length > 0)
      {
        this.partnerInfo = partnerInfo
      }
      if(saleChInfo.length > 0)
      {
        this.saleChInfo = saleChInfo
      }      
    },

    changeExpCatCode1(expCatCode1, idx){
      let expInfo1 = this.expInfo1.filter(e => {return e.expCategory === expCatCode1})

      if(expInfo1.length > 0)
      {
        this.expInfo1[idx] = expInfo1
      }
    },

    changePaymethod(param,pM,idx){
      if(param === 'C' && idx === '')
      {
        let payCodeList = this.finCodeList.filter((item) => {
          return item.fCategory2 == pM
        })
        if(payCodeList.length > 0)
        {
          this.payCodeList = payCodeList
        }
      }
      if(param === 'R' && idx >= 0)
      {
        let payCodeListB = this.finCodeListB.filter((item) => {
          return item.fCategory2 == pM
        })
        if(payCodeListB.length > 0)
        {
          this.payCodeListB[idx] = payCodeListB
        }
      }
    },

    async getBankInfo(pCode, wFlag){
      let partnerInfoByCode = await this.$api("/api/getPartnerInfoByCode", { param: [pCode] });
      
      if(partnerInfoByCode.length > 0)
      {
        if(wFlag === "C")
        {
          this.partnerInfoByCode = partnerInfoByCode
          this.bankCode = partnerInfoByCode[0].bankCode
          this.bAccount = partnerInfoByCode[0].bankAccount
          this.accHolder = partnerInfoByCode[0].accHolder
        }
        else if(wFlag != "C")
        {
          this.dWithdrawalInfo[wFlag].bankCode = partnerInfoByCode[0].bankCode
          this.dWithdrawalInfo[wFlag].bankAccount = partnerInfoByCode[0].bankAccount
          this.dWithdrawalInfo[wFlag].accHolder = partnerInfoByCode[0].accHolder
        }
      }
    },

    getExRate(param,cCode){
      if(param === "D")
      {
        let dExRate = this.finCodeListB.filter((item) => {
          return item.fCodeNo == cCode
        })
        this.dExRate = (dExRate[0].feeRate != null) ? dExRate[0].feeRate : '1.00'
      }
      else if(param === "W")
      {
        let expExRate = this.finCodeListB.filter((item) => {
          return item.fCodeNo == cCode
        })
        this.expExRate = (expExRate[0].feeRate != null) ? expExRate[0].feeRate : '1.00'

        this.expConvMoney = Math.trunc((this.expAmt*1) * (this.expExRate*1))
      }
    },

    getExRate1(cCode, idx, param){
      let dExRate_tmp = this.finCodeListB.filter((item) => {
        return item.fCodeNo == cCode
      })

      if(param === "D")
      {
        this.dDepositInfo[idx].dExRate = (dExRate_tmp[0].feeRate != null) ? dExRate_tmp[0].feeRate : '1.00'
      }
      else if(param === "W")
      {
        this.dWithdrawalInfo[idx].dExRate = (dExRate_tmp[0].feeRate != null) ? dExRate_tmp[0].feeRate : '1.00'
      }
    },

    getFeeRate(cCode, dFlag){
      let dFeeRate = this.finCodeList.filter((item) => {
        return item.fCodeNo == cCode
      })

      if(dFlag === "D")
      {
        this.dFeeRate = (dFeeRate[0].feeRate != null) ? dFeeRate[0].feeRate : '0'
      }
      else if(dFlag === "W")
      {
        this.expFeeRate = (dFeeRate[0].feeRate != null) ? dFeeRate[0].feeRate : '0'
      }
      
    },
    getFeeRate1(cCode, idx, param){
      let dFeeRate_tmp = this.finCodeListB.filter((item) => {
        return item.fCodeNo == cCode
      })

      if(param === "D")
      {
        this.dDepositInfo[idx].dFeeRate = (dFeeRate_tmp[0].feeRate != null) ? dFeeRate_tmp[0].feeRate : '0'
      }
      else if(param === "W")
      {
        this.dWithdrawalInfo[idx].dFeeRate = (dFeeRate_tmp[0].feeRate != null) ? dFeeRate_tmp[0].feeRate : '0'
      }      
    },

    async getDepositInfo(dealCode){
      let dUseFlag = 'Y'

      if(this.newDealFlag === "Y")
      {
        //0건이어도 반드시 갱신 - 기존에는 0건이면 이전 목록이 화면에 남는 버그가 있었음
        let salesHistoryInfo = await this.$api("/api/getDealHistory_sale", {param:[ dealCode ]})
        this.salesHistoryInfo = Array.isArray(salesHistoryInfo) ? salesHistoryInfo : []

        let payHistory = await this.$api("/api/proc_readDealHistoryPay_sale", {param:[ dealCode ]})

        if(payHistory && payHistory.length > 0 && payHistory[0].length > 0)
        {
          let mapped = payHistory[0].map(d => {
            d.dDate = this.getDateFormat(d.insDate)
            return d
          })

          //마킹형 취소(proc_cxlSplitInfo)는 상쇄행이 없어 합산/짝맞추기 전에 먼저 제외해야 함
          let activeRows = mapped.filter(d => !this.isMarkedCancelPay(d))

          //CX 상쇄쌍(+N/-N)은 화면에서 제외 - 순수 유효입금만 표시
          this.dDepositInfo = this.filterOffsettingPayPairs(activeRows)

          //④입금액: 마킹형 취소를 뺀 나머지 전체 합산(CX 상쇄쌍은 더하면 0이라 포함해도 무방)
          this.sumOfConvMoney = activeRows.reduce((acc, cur) => acc + (cur.payAmt * 1 || 0), 0)
        }
        else
        {
          this.dDepositInfo = []
          this.sumOfConvMoney = 0
        }
      }
      else
      {
        let dDepositInfo = await this.$api("/api/proc_readDealHistoryDetail", {param:[
          dealCode, 'D', dUseFlag
        ]})

        if(dDepositInfo.length > 0)
        {
          this.dDepositInfo = dDepositInfo[0];

          let i = 0;
          let sumOfConvMoney = 0;

          while(i < this.dDepositInfo.length)
          {
            this.dDepositInfo[i].dDate = this.getDateFormat(this.dDepositInfo[i].dDate)
            this.dDepositInfo[i].dConvMoney = Math.trunc((this.dDepositInfo[i].dPrice * 1) * (this.dDepositInfo[i].dExRate * 1))

            sumOfConvMoney += this.dDepositInfo[i].dConvMoney
            this.dDepositInfo[i].dCalBalance = (this.dealInfoDetail.dealPrice_tot * 1) - sumOfConvMoney * 1
            this.dDepositInfo[i].handler = this.dDepositInfo[i].upd || this.dDepositInfo[i].ins

            i++;
          }

          sumOfConvMoney = this.dDepositInfo.reduce((acc, cur) => acc + (cur.dPrice * cur.dExRate), 0);
          this.sumOfConvMoney = sumOfConvMoney
        }
        else
        {
          this.dDepositInfo = []
          this.sumOfConvMoney = 0
        }
      }


      let dWithdrawalInfo = await this.$api("/api/proc_readDealHistoryDetail", {param:[
        dealCode, 'W', dUseFlag
      ]})

      if(dWithdrawalInfo.length > 0)
      {
        this.dWithdrawalInfo = dWithdrawalInfo[0];

        let j = 0
        let expTotal = 0
        while(j < this.dWithdrawalInfo.length)
        {
          this.dWithdrawalInfo[j].dDate = this.getDateFormat(this.dWithdrawalInfo[j].dDate)

          let convAmount = Math.trunc((this.dWithdrawalInfo[j].dPrice * 1) * (this.dWithdrawalInfo[j].dExRate * 1)) * (this.dWithdrawalInfo[j].expQty * 1)
          expTotal += convAmount
          j++
        }

        //루프 밖에서 한 번만 대입 - 지출내역이 0건이어도 expTotal이 0으로 정확히 갱신되도록 보장
        this.expTotal = expTotal
      }
      else
      {
        this.dWithdrawalInfo = []
        this.expTotal = 0
      }

      //console.log("dWithdrawalInfo:", this.dWithdrawalInfo)
    },

    async registDeposit(dCode, dFlag) {

      if(dFlag === "O")
      {
        if(!this.dDealDetail)
        {
          this.$refs.reg_dDealDetail.focus();
          return this.$swal.fire("","미수내역을 입력하세요.","warning");
        }
        if(!this.dPrice)
        {
          this.$refs.reg_dPrice.focus();
          return this.$swal.fire("","미수액을 입력하세요.","warning");
        }
        if(!this.dCurCd)
        {
          this.$refs.reg_dCurCd.focus();
          return this.$swal.fire("","통화를 선택하세요.","warning");
        }
        if(!this.dExRate)
        {
          this.$refs.reg_dExRate.focus();
          return this.$swal.fire("","환율을 입력하세요.<br>소숫점 두자리까지 입력가능합니다.","warning");
        }
        if(!this.dPayMethod)
        {
          this.$refs.reg_dPayMethod.focus();
          return this.$swal.fire("","결제수단을 선택하세요.","warning");
        }
        if(!this.dPayCode)
        {
          this.$refs.reg_dPayCode.focus();
          return this.$swal.fire("","결제루트를 선택하세요.","warning");
        }
        if(!this.dFeeRate)
        {
          this.$refs.reg_dFeeRate.focus();
          return this.$swal.fire("","수수율을 입력하세요.<br>소숫점 두자리까지 입력가능합니다.","warning");
        }
        if(!this.dDate)
        {
          this.$refs.reg_dDate.focus();
          return this.$swal.fire("","미수일자를 입력하세요.","warning");
        }
      }
      else if(dFlag === "W")
      {
        if(!this.expCatCode)
        {
          this.$refs.reg_expCatCode.focus();
          return this.$swal.fire("","지출분류를 선택하세요.","warning");
        }

        if(!this.expCode)
        {
          this.$refs.reg_expCode.focus();
          return this.$swal.fire("","지출항목을 선택하세요.","warning");
        }

        if(!this.expPartnerCd)
        {
          this.$swal.fire("","기타지출거래처명을 입력하세요.","warning")
          return false
          
        }      
        else if(this.expPartnerCd === "ZETW")
        {
          if(!this.exPartnerName)
          {
            this.$refs.reg_exPartnerName.focus();
            return this.$swal.fire("","기타지출거래처명을 입력하세요.","warning");
          }
          if(!this.exPartnerTel)
          {
            this.$refs.reg_exPartnerTel.focus();
            return this.$swal.fire("","기타지출거래처 연락처를 입력하세요.","warning");
          }
        }
        
        if(!this.expDate)
        {
          this.$refs.reg_expDate.focus();
          return this.$swal.fire("","지출일자를 입력하세요.","warning");
        }

        if(!this.expAmt)
        {
          this.$refs.reg_expAmt.focus();
          return this.$swal.fire("","지출액을 입력하세요.","warning");
        }

        if(!this.expCurCd)
        {
          this.$refs.reg_expCurCd.focus();
          return this.$swal.fire("","결제통화를 선택하세요.","warning");
        }
        if(!this.expExRate)
        {
          this.$refs.reg_expExRate.focus();
          return this.$swal.fire("","환율을 입력하세요.<br>소숫점 두자리까지 입력가능합니다.","warning");
        }

        if(!this.expPayMethod)
        {
          this.$refs.reg_expPayMethod.focus();
          return this.$swal.fire("","지출수단1을 선택하세요.","warning");
        }

        if(!this.expPayCode)
        {
          this.$refs.reg_expPayCode.focus();
          return this.$swal.fire("","지출수단2를 선택하세요.","warning");
        }

        if(!this.expQty)
        {
          this.$refs.reg_expQty.focus();
          return this.$swal.fire("","지출수량(건)을 입력하세요.","warning");
        }
      }
      else if(dFlag === "S")
      {
        if(!this.cusName)
        {
          this.$refs.cusName.focus();
          return this.$swal.fire("","고객명을 입력하세요","warning");
        }
        if(!this.cusCnt)
        {
          this.$refs.cusCnt.focus();
          return this.$swal.fire("","인원수를 입력하세요","warning");
        }
        if(!this.dSalePrice)
        {
          this.$refs.dSalePrice.focus();
          return this.$swal.fire("","판매액을 입력하세요","warning");
        }
        if(!this.dSaleFee)
        {
          this.$refs.dSaleFee.focus();
          return this.$swal.fire("","판매수수료를 입력하세요","warning");
        }
      }

      else if(dFlag === "SA")
      {
        if(!this.sa_cusName)
        {
          this.$refs.sa_cusName.focus();
          return this.$swal.fire("","고객명을 입력하세요","warning");
        }

        //판매수단을 먼저 확정 - TAX 여부에 따라 인원 검증기준이 달라지므로 인원체크보다 앞에서 확인
        if(!this.sa_channelCode)
        {
          this.$refs.channelCode.focus();
          return this.$swal.fire("","판매수단을 검색하여 선택하세요","warning");
        }

        let isTax = this.sa_channelCode.toUpperCase() === 'TAX'

        if(isTax)
        {
          //TAX건은 인원을 집계하지 않으므로 0으로 고정 (엑셀 일괄등록/askTaxProcess와 동일 기준)
          this.sa_cusCnt = 0
        }
        else if(!this.sa_cusCnt || this.sa_cusCnt <= 0)
        {
          this.$refs.sa_cusCnt.focus();
          return this.$swal.fire("","인원수를 입력하세요","warning");
        }

        if(this.sa_dSalePrice < 0 || this.sa_dSalePrice === "")
        {
          this.$refs.sa_dSalePrice.focus();
          return this.$swal.fire("","판매액이 없거나 0원 미만입니다","warning");
        }
        if(this.sa_dSaleFee < 0 || this.sa_dSaleFee === "")
        {
          this.$refs.sa_saleFee.focus();
          return this.$swal.fire("","판매수수료를 입력하세요","warning");
        }
      }



      let insId = this.user.handlerId;
      let dUseFlag = "Y"

      let ins_dealHistory = []

      if(dFlag === "O")
      {
        let dFlag = "D"
        let exPartnerName = ""
        let exPartnerTel = ""
        let outStFlag = "Y"

        ins_dealHistory = await this.$api("/api/proc_createDealHistory", {param: [
          dCode, this.dPrice, insId,
          dFlag, this.dCurCd, this.dExRate, this.dPrice, this.dPayMethod, this.dPayCode, this.dFeeRate, this.dDealDetail, this.dPartnerCd, this.dDepositor, this.dDate, this.dDetailRemarks, dUseFlag, this.dealInfoDetail.dealPrice_tot, exPartnerName, exPartnerTel,'','0','', outStFlag, '', '', ''
        ]});
      }
      else if(dFlag === "W")
      {
        let dDepositor = ""

        ins_dealHistory = await this.$api("/api/proc_createDealHistory", {param: [
          dCode, this.expAmt, insId,
          dFlag, this.expCurCd, this.expExRate, this.expAmt, this.expPayMethod, this.expPayCode, this.expFeeRate, this.expName, this.expPartnerCd, dDepositor, this.expDate, this.expRemarks, dUseFlag, this.dealInfoDetail.dealPrice_tot, this.exPartnerName, this.exPartnerTel, this.expCode,this.expQty, this.expCatCode, '', this.bankCode, this.bAccount, this.accHolder
        ]});
      }

      else if(dFlag === "SA")
      {
        let sa_dFlag = "S"
        let newFlag = "Y"
        let sa_dSalePrice_tot = 0
        sa_dSalePrice_tot = this.sa_dSalePrice*1 - this.sa_dSaleFee*1
        let payEndFlag = "N"

        ins_dealHistory = await this.$api("/api/proc_createDealHistory_sale", {param: [
          dCode, sa_dSalePrice_tot, newFlag,
          this.sa_cusName, sa_dFlag, this.sa_cusCnt, this.sa_channelCode, this.sa_channelResCode, this.sa_dSalePrice, this.sa_dSaleFee, this.sa_dSaleMemo, dUseFlag, payEndFlag, insId
        ]});
      }

      //affectedRows<0 만 보던 것을 isApiError로 변경 - {error} 응답과 통신오류(undefined)도 에러로 처리
      if(this.isApiError(ins_dealHistory)) 
      {
        let msg = (ins_dealHistory && ins_dealHistory.error && ins_dealHistory.error.sqlMessage) || '서버 응답 없음'
        this.$swal.fire('','처리도중 에러가 발생했습니다.('+ msg +')', 'error')
      }
      else 
      {
        this.$swal.fire('','내역을 저장하였습니다.', 'success');

        if(dFlag === "O")
        {
          this.dDealDetail = ""
          this.dPrice = 0
          this.dCurCd = ""
          this.dExRate = 1.00
          this.dPayMethod = ""
          this.dPayCode = ""
          this.dFeeRate = 0.00
          this.dDepositor = ""
          this.dPartnerCd = ""
          this.dDate = ""
          this.dDetailRemarks = ""
        }
        else if(dFlag === "W")
        {
          this.expCatCode = ""
          this.expCode = ""
          this.expPartnerCd = ""
          this.exPartnerName = ""
          this.exPartnerTel = ""
          this.expDate = ""
          this.expAmt = 0
          this.expCurCd = ""
          this.expExRate = 1.00
          this.expConvMoney = 0
          this.expQty = 1
          this.expRemarks = ""
          this.expPayMethod = ""
          this.expPayCode = ""
          this.expFeeRate = 0.00
          this.bankCode = ""
          this.bAccount = ""
          this.accHolder = ""
          this.expPartnerKeyword = ""        // 거레처값 초기화
          this.expPartnerSearchResult = []          
        }
        else if(dFlag === "SA")
        {
          //TAX처리 팝업에 넘기기 위해, 입력값 초기화 전에 미리 보존
          let savedCusName = this.sa_cusName
          let savedMemo = this.sa_dSaleMemo

          this.sa_cusName = ""
          this.sa_cusCnt = 0
          this.sa_dSalePrice = 0
          this.sa_dSaleFee = 0
          this.sa_dSaleMemo = ""
          this.sa_channelCode = ""
          this.sa_channelResCode = ""
          this.sa_channelKeyword = ""
          this.sa_channelSearchResult = []

          await this.askTaxProcess(dCode, savedCusName, savedMemo)
        }

        this.getDealInfoDetail(this.dealCode)
      }
    },

    // 판매내역등록(SA) 성공 직후 TAX처리 여부 확인 - Y면 방금 등록한 내용 기준으로 TAX수단 판매내역을 추가생성
    // ※ TAX건은 원 판매건의 부가건이므로 인원은 0으로 고정(원 판매건과 인원 중복계산 방지)
    async askTaxProcess(dCode, cusName, memo){
      const { value: taxAmt } = await this.$swal.fire({
        html: 'TAX처리를 하시겠습니까?<br><span style="font-size:small; color:gray;">처리할 경우 TAX 금액을 입력하세요(숫자만)</span>',
        input: 'number',
        inputPlaceholder: "TAX 금액",
        showCancelButton: true,
        confirmButtonText: 'Y',
        cancelButtonText: 'N',
        inputValidator: (value) => {
          if(!value || isNaN(value) || value * 1 <= 0) return "숫자를 입력하세요."
        }
      })

      if(!taxAmt) return

      let insId = this.user.handlerId
      let sa_dFlag = "S"
      let newFlag = "Y"
      let dUseFlag = "Y"
      let payEndFlag = "N"
      let taxChannelCode = "TAX"
      let taxChannelResCode = ""
      let taxCusCnt = 0          // TAX건 인원은 항상 0
      let taxSaleFee = 0
      let taxSalePrice = taxAmt * 1
      let taxSalePrice_tot = taxSalePrice - taxSaleFee

      let ins_taxHistory = await this.$api("/api/proc_createDealHistory_sale", {param: [
        dCode, taxSalePrice_tot, newFlag,
        cusName, sa_dFlag, taxCusCnt, taxChannelCode, taxChannelResCode, taxSalePrice, taxSaleFee, memo, dUseFlag, payEndFlag, insId
      ]});

      if(this.isApiError(ins_taxHistory))
      {
        let msg = (ins_taxHistory && ins_taxHistory.error && ins_taxHistory.error.sqlMessage) || '서버 응답 없음'
        this.$swal.fire('', 'TAX처리 등록실패(' + msg + ')', 'error')
      }
      else
      {
        this.$swal.fire('', 'TAX처리 판매내역이 추가등록되었습니다.', 'success')
      }
    },

    async confirmDeposit(dCode, sb)
    {
      let confirm_dealHistory_d = await this.$api("/api/confirm_dealHistory_d", {param: [
        "Y", this.user.handlerId, dCode, sb
      ]})

      if(confirm_dealHistory_d.affectedRows < 0)
      {
        this.$swal.fire('', '확정 중 오류가 발생했습니다(confirm_dealHistory_d)', 'error');
        return false;
      }
      else
      {
        this.$swal.fire('', '당해 내역은 확정되었습니다.<br>수정을 위해서는 유권한자에게 확정취소를 요청하세요', 'success');
        location.reload(true);
      }
    },

    async changeDeposit(dCode, sb, idx, param)
    {
      let change_dealHistory_d = []

      if(this.newDealFlag === "Y")
      {
        if(param === "SA")
        {
          //화면은 수단명 기준으로 정렬된 sortedSalesHistoryInfo를 그리므로, 템플릿에서 넘어온 idx는 정렬 후 순번임
          //원본 salesHistoryInfo[idx]로 꺼내면 다른 판매건이 선택되어 클릭한 행이 다른 행 내용으로 덮어써지는 버그가 있었음
          //→ 인덱스가 아닌 subNo(sb)로 정확히 찾도록 변경
          let sh = this.salesHistoryInfo.find(item => item.sa_dSubNo === sb)
          if(!sh)
          {
            this.$swal.fire('', '변경할 판매내역을 찾을 수 없습니다.<br>새로고침 후 다시 시도해주세요.', 'error')
            return false
          }

          change_dealHistory_d = await this.$api("/api/proc_changeDealHistory_sale", {param: [
            dCode, sb,
            sh.sa_cusName, sh.sa_cusCnt, sh.sa_dSalePrice, sh.sa_dSaleFee,
            sh.sa_dSaleChCode, sh.sa_dSaleChResCode, sh.sa_dSaleMemo,
            this.user.handlerId
          ]})
        }
      }

      if(param === "D")
      {
        let dPartnerCd = (this.dDepositInfo[idx].dPartnerCd == 'not') ? "" : this.dDepositInfo[idx].dPartnerCd;
        let dConvMoney = Math.trunc((this.dDepositInfo[idx].dPrice *1) * (this.dDepositInfo[idx].dExRate*1))
        let expCode = ""
        let etcPaName = ""
        let etcPaTel = ""
        let expQty = 0
        let expCatCode = ""
        let bankCode = ""
        let bankAccount = ""
        let accHolder = ""

        change_dealHistory_d = await this.$api("/api/proc_changeDealhistory", {param: [ param, expCode,
          this.dDepositInfo[idx].dDealDetail,this.dDepositInfo[idx].dPrice,this.dDepositInfo[idx].dCurCd,this.dDepositInfo[idx].dExRate,this.dDepositInfo[idx].dPayMethod,this.dDepositInfo[idx].dPayCode,this.dDepositInfo[idx].dFeeRate,this.dDepositInfo[idx].dDepositor,dPartnerCd,this.dDepositInfo[idx].dDate,this.dDepositInfo[idx].dDetailRemarks,this.user.handlerId,dCode,sb,
          this.dDepositInfo[idx].exDepositNo, this.dDepositInfo[idx].exSubNo, dConvMoney,
          etcPaName, etcPaTel, expQty, expCatCode, bankCode, bankAccount, accHolder
        ]})
      }
      else if(param === "W")
      {
        let dDepositor = ""
        let exDepositNo = ""
        let exSubNo = 0
        let dConvMoney = 0
        
        change_dealHistory_d = await this.$api("/api/proc_changeDealhistory", {param: [ param, this.dWithdrawalInfo[idx].expCode,
          this.dWithdrawalInfo[idx].dDealDetail,this.dWithdrawalInfo[idx].dPrice,this.dWithdrawalInfo[idx].dCurCd,this.dWithdrawalInfo[idx].dExRate,this.dWithdrawalInfo[idx].dPayMethod,this.dWithdrawalInfo[idx].dPayCode,this.dWithdrawalInfo[idx].dFeeRate,dDepositor,this.dWithdrawalInfo[idx].dPartnerCd,this.dWithdrawalInfo[idx].dDate,this.dWithdrawalInfo[idx].dDetailRemarks,this.user.handlerId,dCode,sb,
          exDepositNo, exSubNo, dConvMoney,
          this.dWithdrawalInfo[idx].etcPaName, this.dWithdrawalInfo[idx].etcPaTel, this.dWithdrawalInfo[idx].expQty, this.dWithdrawalInfo[idx].expCatCode,
          this.dWithdrawalInfo[idx].bankCode, this.dWithdrawalInfo[idx].bankAccount, this.dWithdrawalInfo[idx].accHolder
        ]})
      }

      //{error} 응답을 성공으로 오판하던 문제 수정 - 통신오류(undefined)도 에러로 처리
      if(this.isApiError(change_dealHistory_d))
      {
        let msg = (change_dealHistory_d && change_dealHistory_d.error && change_dealHistory_d.error.sqlMessage) || '서버 응답 없음'
        this.$swal.fire('','변경오류('+ msg +')', 'error')
        return false;
      }
      else
      {
        this.$swal.fire('', '내역이 변경되었습니다.', 'success');
        this.getDealInfoDetail(this.dealCode)
      }
    },

    async excludeOutSt(val){
      let dSubNo = val
      let dUseFlag = "N"
      let dFlag = "D"
      let delId = this.user.handlerId

      let exclude_outStFlag = await this.$api("/api/changeOutStFlag", {param: [
        dUseFlag, delId, dSubNo, dFlag
      ]})

      if(exclude_outStFlag.affectedRows > 0)
      {
        this.$swal.fire('', '미수내역이 삭제되었습니다', 'success');
        location.reload(true);
      }
      else
      {
        this.$swal.fire('', '미수삭제 중 오류가 발생했습니다.<br>오류가 반복되는 경우, 관리자에게 문의해 주세요.', 'warninig');
        location.reload(true);
      }
    },

    async excludeDeposit(dCode, sb, idx, param, expCode)
    {
      let useFlag = "N"
      let delId = this.user.handlerId
      let exclude_dealHistory_d = []

      if(param === "D")
      {
        let confirmDel = await this.$swal.fire({
          html: '이 미수/입금 내역을 삭제하시겠습니까?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오'
        })
        if(!confirmDel.isConfirmed) return

        exclude_dealHistory_d = await this.$api("/api/proc_excludeDealHistory", {param: [param,
          useFlag, delId, dCode, sb,
          this.dDepositInfo[idx].exDepositNo, this.dDepositInfo[idx].exSubNo
        ]})
      }
      else if(param === "W")
      {
        let confirmDel = await this.$swal.fire({
          html: '이 지출내역을 삭제하시겠습니까?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오'
        })
        if(!confirmDel.isConfirmed) return

        let exSubNo = 0
        exclude_dealHistory_d = await this.$api("/api/proc_excludeDealHistory", {param: [param,
          useFlag, delId, dCode, sb,
          expCode, exSubNo
        ]})
      }
      else if(param === "SA")
      {
        let sh = this.salesHistoryInfo.find(item => item.sa_dSubNo === sb)
        let currentPayAmt = sh ? (sh.sa_payAmt * 1 || 0) : 0

        let confirmMsg = currentPayAmt > 0
          ? '이 판매건에 매칭된 입금(' + this.getCurrencyFormat(currentPayAmt) + '원)이 있습니다.<br>삭제 시 매칭된 입금도 모두 자동으로 취소처리됩니다.<br>정말 삭제하시겠습니까?'
          : '이 판매내역을 삭제하시겠습니까?'

        let confirmDel = await this.$swal.fire({
          html: confirmMsg,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오'
        })
        if(!confirmDel.isConfirmed) return

        //이미 매칭된 입금이 있으면, 삭제 전에 매칭된 입금건별로 전부 취소처리 (여러 입금건에 나눠 들어온 경우도 대응)
        if(currentPayAmt > 0)
        {
          //이 판매건에 매칭된 입금이력 조회 - 입금건(exDepositNo)별 순매칭액 집계
          let payHistory = await this.$api("/api/getDealHistoryPay_s", {param: [dCode, sb]})

          let grouped = {}
          ;(payHistory || []).forEach(p => {
            let key = p.exDepositNo
            grouped[key] = (grouped[key] || 0) + (p.payAmt * 1 || 0)
          })

          for(let exDepositNo of Object.keys(grouped))
          {
            let netAmt = grouped[exDepositNo]
            if(netAmt <= 0) continue   //이미 순액 0 이하로 상쇄된 건은 건드릴 필요 없음

            let targetPayAmt = currentPayAmt - netAmt

            //해당 입금건의 원본정보(입금자/입금일/은행코드) 조회 - proc_createExdepositSplit 필수 파라미터
            let exdepositInfo = await this.$api("/api/getExdepositInfo", {param: [exDepositNo]})
            let di = (exdepositInfo && exdepositInfo[0]) ? exdepositInfo[0] : {}

            let res = await this.$api("/api/proc_createExdepositSplit", {param: [
              "DS", "",
              exDepositNo, dCode, 0, this.user.handlerId, "Y", sh.sa_dSaleMemo, di.finCd, this.user.handlerId,
              "D", "KRW", 1, 0, "Bank", di.finCd, 0, sh.sa_dSaleMemo, di.depositor, this.getDateFormat(di.depositDate), "Y",
              "Y", sh.sa_cusName, sb, targetPayAmt, "CX"
            ]})

            if(Object.keys(res)[0] === "error")
            {
              this.$swal.fire('', '입금취소 처리 중 오류가 발생했습니다(' + res.error.sqlMessage + ')', 'error')
              return
            }

            currentPayAmt = targetPayAmt   //다음 입금건 처리를 위해 누적값 갱신
          }
        }

        exclude_dealHistory_d = await this.$api("/api/proc_excludeDealHistory_sale", {param: [
          dCode, sb, delId
        ]})
      }

      if(exclude_dealHistory_d.affectedRows < 0)
      {
        this.$swal.fire('','삭제오류('+ exclude_dealHistory_d.error.sqlMessage +')', 'error')
        return false;
      }
      else
      {
        this.$swal.fire('', '당해 내역은 제외되었습니다.', 'success');
        this.getDealInfoDetail(this.dealCode)
      }
    },

    // 입금코드기반으로 검색할 수 있도록 새 창에서 열기
    goToSuppliment_detail(lnk_exCode){
      let routeData = this.$router.resolve({path: "/supExSettlement", query: {lnk_exCode: lnk_exCode}})
      window.open(routeData.href, '_blank')
    },

    triggerSaleExcelUpload(){
      if(this.isUploading) return   //처리 중 재업로드 차단
      this.$refs.saleExcelInput.click()
    },

    handleSaleExcelUpload(event){
      const file = event.target.files[0]
      event.target.value = ""   //같은 파일 재선택 시에도 change 이벤트가 다시 발생하도록 초기화

      if(!file || this.isUploading) return
      this.isUploading = true   //파일읽기 시작 시점부터 잠금(확인팝업 대기 중 재업로드도 차단)

      const reader = new FileReader()
      reader.onload = async (e) => {
        try
        {
          const workbook = XLSX.read(new Uint8Array(e.target.result), { type: 'array' })
          await this.processSaleExcel(workbook)
        }
        catch(err)
        {
          this.$swal.fire('', '엑셀 처리 중 오류가 발생했습니다.<br>' + (err && err.message ? err.message : ''), 'error')
        }
        finally
        {
          this.isLoading = false
          this.isUploading = false
        }
      }
      reader.onerror = () => {
        this.isUploading = false
        this.$swal.fire('', '파일을 읽는 중 오류가 발생했습니다.', 'error')
      }
      reader.readAsArrayBuffer(file)   //readAsBinaryString은 deprecated
    },

    downloadSaleTemplate(){
      let sample = [{
        "고객명": "홍길동",
        "인원": 2,
        "판매가": 500000,
        "판매수수료": 10000,
        "수단코드": (this.saleChInfo[0] ? this.saleChInfo[0].pCode : ""),
        "수단예약번호": "",
        "메모사항": ""
      }]

      let worksheet = XLSX.utils.json_to_sheet(sample)
      worksheet["!cols"] = [
        {wch: 15}, {wch: 8}, {wch: 12}, {wch: 12}, {wch: 10}, {wch: 15}, {wch: 30}
      ]

      let channelRef = this.saleChInfo.map(sch => ({ "수단코드": sch.pCode, "수단명": sch.pName }))
      let worksheet2 = XLSX.utils.json_to_sheet(channelRef)
      worksheet2["!cols"] = [{wch: 10}, {wch: 20}]

      let workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "판매내역양식")
      XLSX.utils.book_append_sheet(workbook, worksheet2, "수단코드참고")

      XLSX.writeFile(workbook, `판매내역_업로드양식_${this.dealCode}.xlsx`)
    },    
    
    // 엑셀 일괄등록
    // - 중복체크는 하지 않음(현업 고지 방침)
    // - 화면에서 휴먼에러 검증 → proc_createDealHistory_sale_bulk 한 번 호출로 전체를 한 트랜잭션 처리
    // - 한 건이라도 실패하면 DB에서 전체 롤백 → "에러가 나면 그 파일은 등록되지 않는다"를 보장
    async processSaleExcel(workbook){
      const worksheet = workbook.Sheets[workbook.SheetNames[0]]

      //raw:true - 셀 표시형식(천단위콤마 등)이 아닌 실제값으로 읽음
      const rawData = XLSX.utils.sheet_to_json(worksheet, { raw: true, defval: "" })

      //완전 빈 행(서식만 남은 행, 공백만 있는 행) 제거 → 헤더 공백 정규화, 엑셀 실제 행번호 보존
      const jsonData = rawData
        .filter(r => Object.values(r).some(v => v !== null && v.toString().trim() !== ''))
        .map(r => {
          let data = {}
          Object.keys(r).forEach(k => { data[k.replace(/\s/g, '')] = r[k] })
          return { rowNo: (r.__rowNum__ !== undefined ? r.__rowNum__ + 1 : null), data }
        })

      if(jsonData.length === 0)
      {
        this.$swal.fire("", "엑셀에 등록할 데이터가 없습니다.", "warning")
        return
      }

      //필수 헤더 확인 - 헤더를 수정/삭제한 경우 컬럼이 통째로 누락되는 것 방지
      const headers = Object.keys(jsonData[0].data)
      const missingHeaders = ['고객명', '인원', '판매가', '수단코드'].filter(h => !headers.includes(h))
      if(missingHeaders.length > 0)
      {
        this.$swal.fire("", `엑셀 양식의 헤더가 올바르지 않습니다.<br>누락: <b>${missingHeaders.join(', ')}</b><br>양식을 다시 내려받아 사용해주세요.`, "error")
        return
      }

      if(jsonData.length > 300)
      {
        this.$swal.fire("", "일괄등록은 최대 300건까지 가능합니다.", "warning")
        return
      }

      //1) 사전검증 - 오타/누락 등 휴먼에러 체크 (한 건이라도 오류면 전체 중단)
      let errors = []
      let validRows = []

      jsonData.forEach((item, idx) => {
        let row = item.data
        let rowNo = item.rowNo || (idx + 2)
        let cusName = (row['고객명'] || "").toString().trim()
        let cusCnt = this.toNum(row['인원'])
        let salePrice = this.toNum(row['판매가'])
        let saleFee = this.toNum(row['판매수수료'])
        let channelCodeInput = (row['수단코드'] || "").toString().trim()
        let isTax = channelCodeInput.toUpperCase() === 'TAX'
        let channelResCode = (row['수단예약번호'] || "").toString().trim()
        let saleMemo = (row['메모사항'] || "").toString().trim()

        if(isNaN(saleFee)) saleFee = 0

        if(!cusName) { errors.push(`${rowNo}행: 고객명이 없습니다.`); return }
        if(cusName.length > 50) { errors.push(`${rowNo}행: 고객명은 50자를 초과할 수 없습니다.`); return }
        // if(isNaN(cusCnt) || cusCnt <= 0 || !Number.isInteger(cusCnt)) { errors.push(`${rowNo}행: 인원이 올바르지 않습니다.`); return }
        if(isNaN(salePrice) || salePrice < 0 || !Number.isInteger(salePrice)) { errors.push(`${rowNo}행: 판매가가 올바르지 않습니다.`); return }
        if(saleFee < 0 || !Number.isInteger(saleFee)) { errors.push(`${rowNo}행: 판매수수료가 올바르지 않습니다.`); return }
        if(!channelCodeInput) { errors.push(`${rowNo}행: 수단코드가 없습니다.`); return }
        if(channelResCode.length > 40) { errors.push(`${rowNo}행: 수단예약번호는 40자를 초과할 수 없습니다.`); return }
        if(saleMemo.length > 300) { errors.push(`${rowNo}행: 메모사항은 300자를 초과할 수 없습니다.`); return }

        //TAX건은 인원을 집계하지 않으므로 입력값과 무관하게 0으로 고정
        if(isTax)
        {
          cusCnt = 0
        }
        else if(isNaN(cusCnt) || cusCnt <= 0 || !Number.isInteger(cusCnt))
        {
          errors.push(`${rowNo}행: 인원이 올바르지 않습니다.`); return
        }

        //수단코드 정확일치 매칭(대소문자 무시)
        let matchedChannel = this.saleChInfo.find(sch => sch.pCode.toUpperCase() === channelCodeInput.toUpperCase())
        if(!matchedChannel) { errors.push(`${rowNo}행: 등록되지 않은 수단코드(${channelCodeInput})입니다.`); return }

        validRows.push({
          rowNo, cusName, cusCnt, salePrice, saleFee,
          channelCode: matchedChannel.pCode, channelResCode, saleMemo
        })
      })

      if(errors.length > 0)
      {
        this.$swal.fire({
          title: '엑셀 검증 오류',
          html: `오류가 있어 <b>어떤 내역도 등록되지 않았습니다.</b><br>
                아래 오류를 수정한 후, 파일 전체를 다시 업로드해주세요.<br><br>
                ${errors.slice(0,20).join('<br>')}${errors.length > 20 ? `<br>...외 ${errors.length-20}건` : ''}`,
          icon: 'error'
        })
        return
      }

      //2) 확인 후 등록 진행
      let confirm = await this.$swal.fire({
        html: `총 ${validRows.length}건을 판매내역으로 등록합니다.<br>처리 중에는 다른 작업을 할 수 없습니다.<br>계속하시겠습니까?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '등록',
        cancelButtonText: '취소'
      })
      if(!confirm.isConfirmed) return

      this.isLoading = true   //화면 잠금 시작

      try
      {
        //bulk 프로시저 입력 JSON (키 이름은 프로시저의 JSON_VALUE 경로와 일치해야 함)
        let rows = validRows.map(r => ({
          rowNo:     r.rowNo,
          cusName:   r.cusName,
          cusCnt:    r.cusCnt,
          salePrice: r.salePrice,
          saleFee:   r.saleFee,
          chCode:    r.channelCode,
          chResCode: r.channelResCode,
          memo:      r.saleMemo
        }))

        let res = await this.$api("/api/proc_createDealHistory_sale_bulk", {param: [
          this.dealCode, this.user.handlerId, JSON.stringify(rows)
        ]})

        //응답 없음(통신오류/타임아웃) - 서버에서 커밋됐는지 알 수 없으므로 재업로드 전에 확인 유도
        if(!res)
        {
          this.$swal.fire({
            icon: 'warning',
            html: `서버 응답을 받지 못했습니다.<br><br>
                   등록이 <b>완료되었을 수도</b> 있습니다.<br>
                   화면의 판매내역을 확인한 뒤, <b>반영되지 않은 경우에만</b> 다시 업로드해주세요.`
          })
          return
        }

        //DB 오류 - 프로시저에서 전체 롤백되었으므로 한 건도 등록되지 않은 상태
        if(this.isApiError(res))
        {
          let msg = (res.error && res.error.sqlMessage) || ''
          msg = msg.replace('Sorry! An error occured: ', '').replace('. Transaction rolled back.', '')

          this.$swal.fire({
            icon: 'error',
            html: `등록 중 오류가 발생해 <b>한 건도 등록되지 않았습니다.</b><br>
                   (${msg})<br><br>
                   오류를 수정한 후, 파일 전체를 다시 업로드해주세요.`
          })
          return
        }

        //성공 - 프로시저 결과셋(insCnt, firstSubNo, lastSubNo)
        let result = (Array.isArray(res) && Array.isArray(res[0]) && res[0][0]) ? res[0][0] : null
        let insCnt = result && result.insCnt ? result.insCnt : validRows.length

        this.$swal.fire('', `${insCnt}건이 등록되었습니다.`, 'success')
      }
      finally
      {
        this.isLoading = false   //화면 잠금 해제
        await this.getDealInfoDetail(this.dealCode)   //성공/실패/응답없음 모두 최신상태로 갱신
      }
    },
  }
}
</script>

<style scoped>
  html {
    scroll-behavior: smooth;
  }

.ag-header-cell-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ag-theme-balham ::ng-deep .ag-header-cell .ag-header-cell-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.resize-select {
    width: 100%;
    box-sizing: border-box;
    font-size: smaller;
  }

  .resize-input {
    width: 100%;
    box-sizing: border-box;
    font-size: smaller;
  }

  .row-highlight {
    animation: highlightFade 2s ease;
  }
  @keyframes highlightFade {
    0% { background-color: #fff3cd; }
    100% { background-color: transparent; }
  }

  /* ===== 섹션 제목 - 컬러바 + 배경으로 구역 구분 ===== */
  .section-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 7px 12px;
    border-left: 4px solid #adb5bd;
    background: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 12px !important;
  }
  .section-title b {
    font-size: 0.95rem;
    letter-spacing: 0.2px;
  }
  .section-title.text-success { border-left-color: #198754; background: #eafaf1; }
  .section-title.text-dark    { border-left-color: #495057; background: #f1f3f5; }
  .section-title.text-primary { border-left-color: #0d6efd; background: #eaf4fc; }
  .section-title.text-info    { border-left-color: #0dcaf0; background: #e7f9fc; }

  /* ===== 테이블 공통 - 헤더행/여백 통일 ===== */
  .main table.table {
    margin-bottom: 1.25rem;
  }
  .main table.table-bordered thead th {
    background: #eef1f4;
    color: #495057;
    font-weight: 600;
    vertical-align: middle;
  }

  /* ===== [ 판매현황 ] 요약 테이블 ===== */
  .summary-table {
    text-align: center;
    border: 2px solid #333 !important;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  }
  .summary-table th {
    background-color: #6c757d;
    color: #ffffff;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 0.4px;
    padding: 0.5rem 0.4rem;
    border: 1px solid #5a6268 !important;
  }
  .summary-table td {
    background-color: #ffffff;
    font-size: 1.1rem;
    font-weight: 700;
    padding: 0.9rem 0.4rem;
    border: 1px solid #dee2e6 !important;
    vertical-align: middle;
    font-variant-numeric: tabular-nums;
  }
  .summary-sub {
    display: inline-block;
    font-size: 0.7rem;
    font-weight: 400;
    color: #868686;
    margin-left: 4px;
  }

  /* ===== [ 판매내역 ] 리스트 - 컬럼 그룹 구분이 핵심 =====
    그룹1(1~2열: 번호/고객명) - 기본
    그룹2(3열: 수단명) - 읽기전용 식별정보, 연한 회색톤
    그룹3(4~6열: 인원/①판매가/②판매수수료) - 직접입력값
    그룹4(7~9열: ③총판매가/④입금액/미수과입) - 시스템 자동계산값, 파란톤 배경으로 강조
    그룹5(10~11열: 메모/액션) - 그룹4와 구분되게 왼쪽에 굵은 경계선
  */
  .sales-list-table {
    font-size: 0.8rem;
    border-collapse: separate;
    border-spacing: 0;
  }
  .sales-list-table th,
  .sales-list-table td {
    padding: 0.3rem 0.4rem;
    vertical-align: middle;
  }
  .sales-list-table input,
  .sales-list-table textarea {
    font-size: 0.8rem;
    padding: 0.2rem 0.35rem;
  }
  .sales-list-table textarea {
    height: 32px;
    min-height: 32px;
  }
  .sales-list-table .btn-sm {
    font-size: 0.7rem;
    padding: 0.15rem 0.4rem;
  }
  .sales-list-table .badge {
    font-size: 0.65rem;
  }

  /* 수단명(3열) - 읽기전용 식별정보 톤 */
  .sales-list-table th:nth-child(3),
  .sales-list-table td:nth-child(3) {
    background-color: #fafafa;
    color: #6c757d;
  }

  /* 계산값 그룹(7~9열) - 배경 강조 */
  .sales-list-table th:nth-child(7),
  .sales-list-table th:nth-child(8),
  .sales-list-table th:nth-child(9),
  .sales-list-table td:nth-child(7),
  .sales-list-table td:nth-child(8),
  .sales-list-table td:nth-child(9) {
    background-color: #f2f7fc;
    white-space: nowrap;
  }

  /* 숫자 컬럼 - 우측정렬 */
  .sales-list-table td:nth-child(5),
  .sales-list-table td:nth-child(6),
  .sales-list-table td:nth-child(7),
  .sales-list-table td:nth-child(8),
  .sales-list-table td:nth-child(9) {
    text-align: right;
  }
  .sales-list-table input[type="number"] {
    text-align: right;
  }

  /* 그룹 경계선 - 굵은 세로선으로 확실히 구분 */
  .sales-list-table th:nth-child(2),
  .sales-list-table td:nth-child(2),
  .sales-list-table th:nth-child(7),
  .sales-list-table td:nth-child(7),
  .sales-list-table th:nth-child(10),
  .sales-list-table td:nth-child(10) {
    border-left: 2px solid #c3cdd6;
  }

  /* 수단별 합계 - 호버 레이어 */
  .channel-summary-trigger {
    position: relative;
    display: inline-block;
    margin-left: 10px;
    padding-left: 10px;
    cursor: help;
    font-size: 0.9rem;
    color: #000;
    border-bottom: 1px dashed #000;
  }
  .channel-summary-layer {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 20;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    padding: 6px 8px;
    min-width: 220px;
    max-height: 300px;
    overflow-y: auto;
  }
  .channel-summary-trigger:hover .channel-summary-layer {
    display: block;
  }
  .channel-summary-table {
    width: 100%;
    font-size: 0.9rem;
    border-collapse: collapse;
  }
  .channel-summary-table th {  
    background: #eef1f4;
    padding: 3px 6px;
    text-align: left;
    white-space: nowrap;
  }
  .channel-summary-table td {
    padding: 3px 6px;
    border-bottom: 1px solid #f1f3f5;
    white-space: nowrap;
  }  
</style>